import React, { useState, useEffect, useRef } from 'react';
import { Container, Row, Col, Button, Image, Card, Form, Badge, Accordion, Modal } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { FaVideo, FaPhoneAlt, FaEye, FaRegHeart, FaHeart, FaShareAlt, FaRegPaperPlane } from "react-icons/fa";
import Footer from '../../Footer/Footer';
import { useNavigate } from 'react-router-dom';
import BaseUrl from '../../ApiServices/BaseUrl';
import AgencyNavbar from '../../Pages/Navbar/AgencyNavbar';
import moment from 'moment';
import Swal from 'sweetalert2';
import AgencyReportCandidate from './AgencyReportCandidate';
import SendAlertScrollPrompt from '../../Common/SendAlertPrompt/SendAlertScrollPrompt';
import { triggerSendAlertAction } from '../../Common/SendAlertPrompt/sendAlertAction';
import './ViewCandidates.css';
import { HiOutlineBellAlert } from 'react-icons/hi2';
import { getVisibleOfferBadgeText, getVisibleSourceLabel, hasHighlightedSourceLabel, hasVisibleOfferBadge } from '../../../utils/candidateBadges';
import CandidateCardHeading from '../../Common/CandidateCardHeading';

function ViewCandidates() {
    const [candidates, setCandidates] = useState([]);
    const [filteredCandidates, setFilteredCandidates] = useState([]);
    const [searchInput, setSearchInput] = useState('');
    const [searchTerm, setSearchTerm] = useState('');
    const autoSearchTimeoutRef = useRef(null);
    const isAutoSearchingRef = useRef(false);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [unlockedIds, setUnlockedIds] = useState([]);
    const navigate = useNavigate();
    const [showMoreJobPosition, setShowMoreJobPosition] = useState(false);
    const [showMoreJobType, setShowMoreJobType] = useState(false);
    const [showMoreLanguage, setShowMoreLanguage] = useState(false);
    const [showMoreMainSkills, setShowMoreMainSkills] = useState(false);
    const [showFiltersMobile, setShowFiltersMobile] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    // Modal states
    const [showMessageModal, setShowMessageModal] = useState(false);
    const [messageContent, setMessageContent] = useState("I'm interested");
    const [selectedCandidate, setSelectedCandidate] = useState(null);
    const [showReportModal, setShowReportModal] = useState(false);
    const [selectedCandidateForReport, setSelectedCandidateForReport] = useState(null);
    const [showShareModal, setShowShareModal] = useState(false);
    const [shareContent, setShareContent] = useState('');
    const [shareUrl, setShareUrl] = useState('');
    const [showLocation, setShowLocation] = useState(false);
    const [showContractStatus, setShowContractStatus] = useState(false);
    const [showPostedBy, setShowPostedBy] = useState(false);
    const [showStartDate, setShowStartDate] = useState(false);

    // Shortlist state
    const [shortlistedCandidates, setShortlistedCandidates] = useState({});

    // Get agency info
    const user = JSON.parse(localStorage.getItem("user")) || {};
    const agencyId = user.id || '';
    const planName = user.plan_name || '';
    const planStartDate = user.plan_startdate || '';
    const planEndDate = user.plan_enddate || '';

    // Filter states
    const [jobPosition, setJobPosition] = useState({
        maid: false,
        driver: false,
        cook: false,
        nanny: false,
        nurse: false,
        houseboy: false,
        tailor: false,
        teacher: false,
        trainer: false,
        gardener: false,
        butler: false,
        housekeeper: false,
        laundryWorker: false,
        personalAssistant: false,
        caregiver: false,
        elderCareCompanion: false,
        petSitter: false,
        houseManager: false,
        cleaner: false,
        maintenanceWorker: false,
        babySitter: false,
        tutor: false,
        chauffeur: false,
        housemaid: false,
        kitchenStaff: false,
        diningRoomAttendant: false,
        personalChef: false,
        eventCoordinator: false,
        householdAdministrator: false,
        domesticAssistant: false
    });
    const [jobCountry, setJobCountry] = useState({
        qatar: false,
        uae: false,
        saudiArabia: false,
        kuwait: false,
        bahrain: false,
        oman: false,
        usa: false,
        canada: false,
        uk: false,
        australia: false,
        germany: false,
        france: false,
        italy: false,
        spain: false,
        netherlands: false,
        belgium: false,
        switzerland: false,
        sweden: false,
        norway: false,
        denmark: false,
        finland: false,
        japan: false,
        southKorea: false,
        singapore: false,
        malaysia: false,
        china: false,
        hongKong: false,
        newZealand: false,
        southAfrica: false,
        brazil: false,
        mexico: false,
        argentina: false,
        chile: false,
        colombia: false,
        peru: false,
        egypt: false,
        morocco: false,
        algeria: false,
        tunisia: false,
        jordan: false,
        lebanon: false,
        iraq: false,
        iran: false,
        turkey: false,
        cyprus: false,
        malta: false,
        greece: false,
        portugal: false,
        austria: false,
        hungary: false,
        poland: false,
        czechRepublic: false,
        slovakia: false,
        slovenia: false,
        croatia: false,
        romania: false,
        bulgaria: false,
        serbia: false,
        montenegro: false,
        albania: false,
        northMacedonia: false,
        bosniaHerzegovina: false,
        kosovo: false,
        estonia: false,
        latvia: false,
        lithuania: false,
        belarus: false,
        ukraine: false,
        moldova: false,
        georgia: false,
        armenia: false,
        azerbaijan: false,
        kazakhstan: false,
        uzbekistan: false,
        turkmenistan: false,
        kyrgyzstan: false,
        tajikistan: false,
        afghanistan: false,
        pakistan: false,
        india: false,
        bangladesh: false,
        sriLanka: false,
        nepal: false,
        bhutan: false,
        myanmar: false,
        thailand: false,
        laos: false,
        cambodia: false,
        vietnam: false,
        indonesia: false,
        philippines: false,
        brunei: false,
        eastTimor: false,
        papuaNewGuinea: false,
        fiji: false,
        solomonIslands: false,
        vanuatu: false,
        samoa: false,
        tonga: false,
        marshallIslands: false,
        micronesia: false,
        palau: false,
        nauru: false,
        tuvalu: false,
        kiribati: false
    });
    const [showMoreJobCountry, setShowMoreJobCountry] = useState(false);
    const [candidateLocation, setCandidateLocation] = useState({
        india: false,
        bangladesh: false,
        nepal: false,
        sriLanka: false,
        pakistan: false,
        philippines: false,
        indonesia: false,
        myanmar: false,
        vietnam: false,
        cambodia: false,
        thailand: false,
        ethiopia: false,
        kenya: false,
        uganda: false,
        tanzania: false,
        rwanda: false,
        ghana: false,
        nigeria: false,
        sierraLeone: false,
        burundi: false
    });

    const [jobType, setJobType] = useState({
        fullTime: false,
        partTime: false,
        liveIn: false,
        liveOut: false,
        temporary: false,
        permanent: false,
        internship: false,
        contractual: false,
        freelance: false,
        volunteer: false,
        fresher: false
    });

    const [contractStatus, setContractStatus] = useState({
        permanent: false,
        temporary: false,
        contract: false
    });

    const [postedBy, setPostedBy] = useState({
        agency: false,
        directEmployer: false
    });

    const [language, setLanguage] = useState({
        english: false,
        mandarin: false,
        arabic: false,
        hindi: false,
        tagalog: false,
        cantonese: false,
        malay: false,
        tamil: false
    });

    const [mainSkills, setMainSkills] = useState({
        childcare: false,
        elderlyCare: false,
        cooking: false,
        cleaning: false,
        laundry: false,
        ironing: false,
        petCare: false,
        gardening: false
    });

    const [startDate, setStartDate] = useState('');
    const [showMoreLocations, setShowMoreLocations] = useState(false);

    const getSafeString = (value, fallback = '') => {
        if (value === null || value === undefined) return fallback;
        const str = String(value).trim();
        return str || fallback;
    };

    const getDisplayValue = (value, fallback = 'N/A') => {
        if (value === null || value === undefined || value === '') return fallback;
        if (Array.isArray(value)) return value.length > 0 ? value.join(', ') : fallback;
        if (typeof value === 'string') {
            try {
                const parsed = JSON.parse(value.replace(/\\"/g, '"'));
                return Array.isArray(parsed) && parsed.length > 0 ? parsed.join(', ') : (value || fallback);
            } catch {
                return value || fallback;
            }
        }
        return value.toString() || fallback;
    };

    const parseToArray = (val) => {
        if (!val) return [];
        if (Array.isArray(val)) return val;
        if (typeof val === 'string') {
            try {
                const parsed = JSON.parse(val.replace(/\\"/g, '"'));
                return Array.isArray(parsed) ? parsed : [parsed];
            } catch {
                return [val];
            }
        }
        return [val];
    };

    const getCandidateExperienceYears = (profile) => {
        const exp =
            profile?.total_work_experience ||
            profile?.experience_years ||
            profile?.work_experience ||
            profile?.years_of_experience ||
            profile?.total_experience ||
            profile?.total_years_experience ||
            profile?.years_experience ||
            profile?.dtr_years_of_experience_doctor;
        if (typeof exp === 'number') return `${exp} years`;
        return getSafeString(exp, null) || null;
    };

    const getCountriesWorkedFromExperience = (profile) => {
        const expItems = parseToArray(profile?.experience);
        if (!expItems.length) return '';
        const countries = new Set();
        expItems.forEach((exp) => {
            if (!exp || typeof exp !== 'object') return;
            const possible = [
                exp.country,
                exp.work_country,
                exp.employer_country,
                exp.country_name,
                exp.country_experience,
                exp.previous_hospital_country
            ];
            possible.forEach((val) => {
                parseToArray(val).forEach((c) => {
                    const trimmed = getSafeString(c, '');
                    if (trimmed) countries.add(trimmed);
                });
            });
        });
        return countries.size ? Array.from(countries).join(', ') : '';
    };

    const buildCandidateEmailHTML = (candidate, message) => {
        const firstName = getSafeString(candidate?.first_name, '');
        const lastName = getSafeString(candidate?.last_name, '');
        const candidateName = [firstName, lastName].filter(Boolean).join(' ')
            || getSafeString(candidate?.full_name || candidate?.name, 'N/A');
        const categoryRaw = getDisplayValue(
            candidate?.category ||
            candidate?.job_category ||
            candidate?.domestic_worker_category ||
            candidate?.worker_category ||
            candidate?.candidate_category
        );
        const category = categoryRaw === 'N/A'
            ? getDisplayValue(candidate?.job_position || candidate?.position || candidate?.job_title)
            : categoryRaw;
        const experience = getDisplayValue(getCandidateExperienceYears(candidate) ||
            (parseToArray(candidate?.experience).length ? `${parseToArray(candidate.experience).length} previous roles` : null));
        const currentLocation = getDisplayValue(
            candidate?.current_country ||
            candidate?.current_location ||
            candidate?.current_city ||
            candidate?.city ||
            candidate?.country
        );
        const previousExperience = getDisplayValue(
            candidate?.gulf_europe_experience ||
            candidate?.overseas_experience ||
            candidate?.driving_country_experience ||
            candidate?.candidates_country_experience ||
            getCountriesWorkedFromExperience(candidate)
        );
        const baseCurrency = String(candidate?.expected_monthly_salary_currency || '').split(' | ')[0].trim();
        const expectedSalaryRaw =
            (baseCurrency && candidate?.expected_monthly_salary
                ? `${baseCurrency} ${candidate.expected_monthly_salary}`
                : candidate?.expected_monthly_salary_usd
                    ? `USD ${candidate.expected_monthly_salary_usd}`
                    : candidate?.expected_monthly_salary_qar
                        ? `QAR ${candidate.expected_monthly_salary_qar}`
                        : candidate?.expected_monthly_salary_omr
                            ? `OMR ${candidate.expected_monthly_salary_omr}`
                            : candidate?.expected_monthly_salary);
        const expectedSalary = getDisplayValue(expectedSalaryRaw);
        const availabilityRaw =
            candidate?.preferred_start_date === 'Immediate'
                ? 'Immediate'
                : (candidate?.preferred_start_date || candidate?.notice_period || candidate?.availability);
        const availability = getDisplayValue(availabilityRaw);
        const messageHtml = getSafeString(message, '').replace(/\n/g, '<br/>');

        return `
        <div style="font-family: Arial, sans-serif; line-height: 1.6; color: #2c3e50; background-color: #ffffff;">
          <div style="font-size: 18px; font-weight: 700; padding-bottom: 8px; border-bottom: 2px solid #2f86eb;">
            Job Application Interest
          </div>

          <div style="margin: 18px 0 16px 0; padding: 14px 16px; background-color: #f6f8fb; border-left: 4px solid #2f86eb;">
            <div style="font-weight: 700; margin-bottom: 6px;">Message:</div>
            <div style="margin-bottom: 10px; color: #3f4a56;">${messageHtml || 'N/A'}</div>
            <ul style="margin: 8px 0 0 18px; padding: 0; color: #334155;">
              <li><strong>Category:</strong> ${category}</li>
              <li><strong>Total Experience:</strong> ${experience}</li>
              <li><strong>Current Location:</strong> ${currentLocation}</li>
              <li><strong>Previous Gulf/Europe Experience:</strong> ${previousExperience}</li>
              <li><strong>Expected Salary:</strong> ${expectedSalary}</li>
              <li><strong>Notice Period / Availability:</strong> ${availability}</li>
            </ul>
          </div>

          <div style="font-size: 16px; font-weight: 700; margin: 18px 0 8px 0;">Profile Details:</div>
          <table style="width: 100%; border-collapse: collapse; margin: 8px 0 16px 0;">
            <tr>
              <td style="padding: 8px 10px; border: 1px solid #e1e5ea; font-weight: 700; width: 160px; background-color: #f8fafc;">Name:</td>
              <td style="padding: 8px 10px; border: 1px solid #e1e5ea;">${candidateName}</td>
            </tr>
            <tr>
              <td style="padding: 8px 10px; border: 1px solid #e1e5ea; font-weight: 700; background-color: #f8fafc;">Category:</td>
              <td style="padding: 8px 10px; border: 1px solid #e1e5ea;">${category}</td>
            </tr>
            <tr>
              <td style="padding: 8px 10px; border: 1px solid #e1e5ea; font-weight: 700; background-color: #f8fafc;">Experience:</td>
              <td style="padding: 8px 10px; border: 1px solid #e1e5ea;">${experience}</td>
            </tr>
            <tr>
              <td style="padding: 8px 10px; border: 1px solid #e1e5ea; font-weight: 700; background-color: #f8fafc;">Current Location:</td>
              <td style="padding: 8px 10px; border: 1px solid #e1e5ea;">${currentLocation}</td>
            </tr>
          </table>

          <div style="margin-top: 16px; font-size: 12px; color: #7f8c8d;">
            This is an automated message from Gulf Worker job portal.
          </div>
        </div>
      `;
    };

    const handleJobPositionChange = (e) => {
        const { name, checked } = e.target;
        setJobPosition(prev => ({
            ...prev,
            [name]: checked
        }));
    };

    const handleJobCountryChange = (e) => {
        const { name, checked } = e.target;
        setJobCountry(prev => ({
            ...prev,
            [name]: checked
        }));
    };

    const resetAllFilters = () => {
        setJobPosition({
            maid: false,
            driver: false,
            cook: false,
            nanny: false,
            nurse: false,
            houseboy: false,
            tailor: false,
            teacher: false,
            trainer: false,
            gardener: false,
            butler: false,
            housekeeper: false,
            laundryWorker: false,
            personalAssistant: false,
            caregiver: false,
            elderCareCompanion: false,
            petSitter: false,
            houseManager: false,
            cleaner: false,
            maintenanceWorker: false,
            babySitter: false,
            tutor: false,
            chauffeur: false,
            housemaid: false,
            kitchenStaff: false,
            diningRoomAttendant: false,
            personalChef: false,
            eventCoordinator: false,
            householdAdministrator: false,
            domesticAssistant: false
        });
        // Inside resetAllFilters function, add this:
        setJobCountry({
            qatar: false,
            uae: false,
            saudiArabia: false,
            kuwait: false,
            bahrain: false,
            oman: false,
            usa: false,
            canada: false,
            uk: false,
            australia: false,
            germany: false,
            france: false,
            italy: false,
            spain: false,
            netherlands: false,
            belgium: false,
            switzerland: false,
            sweden: false,
            norway: false,
            denmark: false,
            finland: false,
            japan: false,
            southKorea: false,
            singapore: false,
            malaysia: false,
            china: false,
            hongKong: false,
            newZealand: false,
            southAfrica: false,
            brazil: false,
            mexico: false,
            argentina: false,
            chile: false,
            colombia: false,
            peru: false,
            egypt: false,
            morocco: false,
            algeria: false,
            tunisia: false,
            jordan: false,
            lebanon: false,
            iraq: false,
            iran: false,
            turkey: false,
            cyprus: false,
            malta: false,
            greece: false,
            portugal: false,
            austria: false,
            hungary: false,
            poland: false,
            czechRepublic: false,
            slovakia: false,
            slovenia: false,
            croatia: false,
            romania: false,
            bulgaria: false,
            serbia: false,
            montenegro: false,
            albania: false,
            northMacedonia: false,
            bosniaHerzegovina: false,
            kosovo: false,
            estonia: false,
            latvia: false,
            lithuania: false,
            belarus: false,
            ukraine: false,
            moldova: false,
            georgia: false,
            armenia: false,
            azerbaijan: false,
            kazakhstan: false,
            uzbekistan: false,
            turkmenistan: false,
            kyrgyzstan: false,
            tajikistan: false,
            afghanistan: false,
            pakistan: false,
            india: false,
            bangladesh: false,
            sriLanka: false,
            nepal: false,
            bhutan: false,
            myanmar: false,
            thailand: false,
            laos: false,
            cambodia: false,
            vietnam: false,
            indonesia: false,
            philippines: false,
            brunei: false,
            eastTimor: false,
            papuaNewGuinea: false,
            fiji: false,
            solomonIslands: false,
            vanuatu: false,
            samoa: false,
            tonga: false,
            marshallIslands: false,
            micronesia: false,
            palau: false,
            nauru: false,
            tuvalu: false,
            kiribati: false
        });
        setCandidateLocation({
            india: false,
            bangladesh: false,
            nepal: false,
            sriLanka: false,
            pakistan: false,
            philippines: false,
            indonesia: false,
            myanmar: false,
            vietnam: false,
            cambodia: false,
            thailand: false,
            ethiopia: false,
            kenya: false,
            uganda: false,
            tanzania: false,
            rwanda: false,
            ghana: false,
            nigeria: false,
            sierraLeone: false,
            burundi: false
        });
        setJobType({
            fullTime: false,
            partTime: false,
            liveIn: false,
            liveOut: false,
            temporary: false,
            permanent: false,
            internship: false,
            contractual: false,
            freelance: false,
            volunteer: false,
            fresher: false
        });
        setContractStatus({
            permanent: false,
            temporary: false,
            contract: false
        });
        setPostedBy({
            agency: false,
            directEmployer: false
        });
        setLanguage({
            english: false,
            mandarin: false,
            arabic: false,
            hindi: false,
            tagalog: false,
            cantonese: false,
            malay: false,
            tamil: false
        });
        setMainSkills({
            childcare: false,
            elderlyCare: false,
            cooking: false,
            cleaning: false,
            laundry: false,
            ironing: false,
            petCare: false,
            gardening: false
        });
        setStartDate('');
    };

    const handleCandidateLocationChange = (e) => {
        const { name, checked } = e.target;
        setCandidateLocation(prev => ({
            ...prev,
            [name]: checked
        }));
    };

    const handleJobTypeChange = (e) => {
        const { name, checked } = e.target;
        setJobType(prev => ({
            ...prev,
            [name]: checked
        }));
    };

    const handleContractStatusChange = (e) => {
        const { name, checked } = e.target;
        setContractStatus(prev => ({
            ...prev,
            [name]: checked
        }));
    };

    const handlePostedByChange = (e) => {
        const { name, checked } = e.target;
        setPostedBy(prev => ({
            ...prev,
            [name]: checked
        }));
    };

    const handleLanguageChange = (e) => {
        const { name, checked } = e.target;
        setLanguage(prev => ({
            ...prev,
            [name]: checked
        }));
    };

    const handleMainSkillsChange = (e) => {
        const { name, checked } = e.target;
        setMainSkills(prev => ({
            ...prev,
            [name]: checked
        }));
    };

    const handleStartDateChange = (e) => {
        setStartDate(e.target.value);
    };

    const applySearchTerm = async (rawSearchValue) => {
        setSearchTerm(rawSearchValue.trim().toLowerCase());
    };

    const handleSearchSubmit = async (e) => {
        e.preventDefault();
        await applySearchTerm(searchInput);
    };

    const handleSendBulkMessagesClick = () => {
        triggerSendAlertAction({
            navigate,
            user,
            pageKey: 'agency-view-candidates',
            jobPosition: 'Candidate',
            targetRoute: '/agency-send-alert',
            targetRoles: ['agency', 'agency_admin'],
            targetRoleLabel: 'agency',
            registerDefaultTab: 'agency',
            loginDefaultTab: 'agency',
            prefillJobPositionOnContinue: false
        });
    };

    const toggleMoreLocations = () => {
        setShowMoreLocations(!showMoreLocations);
    };

    const handleViewClick = (candidate) => {
        const userId = candidate?.user_id || candidate?.id;
        const firstName = (candidate?.first_name || 'candidate').toString().trim() || 'candidate';
        const safeName = encodeURIComponent(firstName);
        navigate(`/candidateview/${userId}/${safeName}?viewer=agency`, {
            state: { viewer: 'agency' }
        });
    };

    useEffect(() => {
        if (autoSearchTimeoutRef.current) {
            clearTimeout(autoSearchTimeoutRef.current);
        }

        autoSearchTimeoutRef.current = setTimeout(async () => {
            if (isAutoSearchingRef.current) return;

            const normalizedSearchInput = searchInput.trim().toLowerCase();
            if (normalizedSearchInput === searchTerm) return;

            isAutoSearchingRef.current = true;
            try {
                await applySearchTerm(searchInput);
            } finally {
                isAutoSearchingRef.current = false;
            }
        }, 350);

        return () => {
            if (autoSearchTimeoutRef.current) {
                clearTimeout(autoSearchTimeoutRef.current);
            }
        };
    }, [searchInput, searchTerm]);

    // Helper function to format dates correctly
    const formatDate = (dateString) => {
        if (!dateString) return 'N/A';

        try {
            const date = new Date(dateString.includes('T') ? dateString : dateString + 'T00:00:00');
            return date.toLocaleDateString('en-GB', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric'
            });
        } catch (e) {
            console.error('Error formatting date:', e);
            return 'N/A';
        }
    };

    // Helper function to safely parse array fields
    const safeParseArray = (field) => {
        if (Array.isArray(field)) return field;
        if (typeof field === 'string') {
            try {
                const parsed = JSON.parse(field.replace(/\\"/g, '"'));
                return Array.isArray(parsed) ? parsed : [];
            } catch {
                return [];
            }
        }
        return [];
    };

    const getCandidateLicenseSearchValue = (candidate) => {
        return safeParseArray(candidate.driving_license_country)
            .map((item) => String(item || '').toLowerCase())
            .join(' ');
    };

    // Check if user has active subscription
    const hasActiveSubscription = () => {
        const userPlan = planName?.toLowerCase();
        const hasValidPlan = userPlan?.includes('gold') || userPlan?.includes('silver');

        if (!hasValidPlan) return false;

        const currentDate = new Date();
        const planStartDateObj = new Date(planStartDate);
        const planEndDateObj = new Date(planEndDate);

        currentDate.setHours(0, 0, 0, 0);
        planStartDateObj.setHours(0, 0, 0, 0);
        planEndDateObj.setHours(0, 0, 0, 0);

        return currentDate >= planStartDateObj && currentDate <= planEndDateObj;
    };

    useEffect(() => {
        const checkScreenSize = () => {
            const mobile = window.innerWidth < 768;
            setIsMobile(mobile);

            // If desktop, open all filters
            if (!mobile) {
                setShowLocation(true);
                setShowMoreJobPosition(true);
                setShowMoreJobType(true);
                setShowContractStatus(true);
                setShowPostedBy(true);
                setShowMoreLanguage(true);
                setShowMoreMainSkills(true);
                setShowStartDate(true);
                setShowFiltersMobile(true);
            } else {
                // If mobile, close all filters by default
                setShowLocation(false);
                setShowMoreJobPosition(false);
                setShowMoreJobType(false);
                setShowContractStatus(false);
                setShowPostedBy(false);
                setShowMoreLanguage(false);
                setShowMoreMainSkills(false);
                setShowStartDate(false);
                setShowFiltersMobile(false);
            }
        };

        checkScreenSize();
        window.addEventListener('resize', checkScreenSize);
        return () => window.removeEventListener('resize', checkScreenSize);
    }, []);

    useEffect(() => {
        const fetchCandidates = async () => {
            try {
                const response = await fetch(`${BaseUrl}/api/job-seeker`);
                if (!response.ok) {
                    throw new Error('Failed to fetch candidates');
                }
                let data = await response.json();

                // ✅ Filter only candidates with verification_status 'Verified'
                data = data.filter(candidate =>
                    candidate.verification_status?.toLowerCase() === 'verified'
                );

                // Process each candidate to ensure array fields are properly initialized
                data = data.map(candidate => ({
                    ...candidate,
                    language: safeParseArray(candidate.language),
                    main_skills: safeParseArray(candidate.main_skills),
                    preferred_countries: safeParseArray(candidate.preferred_countries),
                    work_experience: safeParseArray(candidate.work_experience),
                    job_position: safeParseArray(candidate.job_position)
                }));

                // Append full URL to profile_photo if exists
                const updatedData = data.map(candidate => {
                    if (candidate.profile_photo) {
                        return {
                            ...candidate,
                            profile_photo: `${BaseUrl}${candidate.profile_photo}`
                        };
                    }
                    return candidate;
                });

                setCandidates(updatedData);
                setFilteredCandidates(updatedData);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchCandidates();
    }, []);

    // Fetch unlocked candidates IDs for this agency
    useEffect(() => {
        const fetchUnlockedIds = async () => {
            if (!agencyId) return;
            try {
                const response = await fetch(`${BaseUrl}/api/agency/contact-unlock/unlocked-ids?agency_id=${agencyId}`);
                if (response.ok) {
                    const data = await response.json();
                    setUnlockedIds(data.unlocked_ids || []);
                }
            } catch (err) {
                console.error('Error fetching unlocked IDs:', err);
            }
        };
        fetchUnlockedIds();
    }, [agencyId]);

    // Apply filters whenever filter criteria change
    useEffect(() => {
        let result = [...candidates];

        // Filter by job position (using category)
        if (Object.values(jobPosition).some(v => v)) {
            result = result.filter(candidate => {
                // Handle job_position as array
                const jobPositions = Array.isArray(candidate.job_position)
                    ? candidate.job_position.map(pos => pos?.toLowerCase() || '')
                    : [candidate.job_position?.toLowerCase() || ''];

                const jobPositionsString = jobPositions.join(' ');

                return (
                    (jobPosition.maid && jobPositionsString.includes('maid')) ||
                    (jobPosition.driver && jobPositionsString.includes('driver')) ||
                    (jobPosition.cook && jobPositionsString.includes('cook')) ||
                    (jobPosition.nanny && jobPositionsString.includes('nanny')) ||
                    (jobPosition.nurse && jobPositionsString.includes('nurse')) ||
                    (jobPosition.houseboy && jobPositionsString.includes('houseboy')) ||
                    (jobPosition.tailor && jobPositionsString.includes('tailor')) ||
                    (jobPosition.teacher && jobPositionsString.includes('teacher')) ||
                    (jobPosition.trainer && jobPositionsString.includes('trainer')) ||
                    (jobPosition.gardener && jobPositionsString.includes('gardener')) ||
                    (jobPosition.butler && jobPositionsString.includes('butler')) ||
                    (jobPosition.housekeeper && jobPositionsString.includes('housekeeper')) ||
                    (jobPosition.laundryWorker && jobPositionsString.includes('laundry')) ||
                    (jobPosition.personalAssistant && jobPositionsString.includes('personal assistant')) ||
                    (jobPosition.caregiver && jobPositionsString.includes('caregiver')) ||
                    (jobPosition.elderCareCompanion && jobPositionsString.includes('elder care')) ||
                    (jobPosition.petSitter && (jobPositionsString.includes('pet') || jobPositionsString.includes('dog walker'))) ||
                    (jobPosition.houseManager && jobPositionsString.includes('house manager')) ||
                    (jobPosition.cleaner && jobPositionsString.includes('cleaner')) ||
                    (jobPosition.maintenanceWorker && (jobPositionsString.includes('maintenance') || jobPositionsString.includes('handyman'))) ||
                    (jobPosition.babySitter && jobPositionsString.includes('baby sitter')) ||
                    (jobPosition.tutor && jobPositionsString.includes('tutor')) ||
                    (jobPosition.chauffeur && jobPositionsString.includes('chauffeur')) ||
                    (jobPosition.housemaid && jobPositionsString.includes('housemaid')) ||
                    (jobPosition.kitchenStaff && jobPositionsString.includes('kitchen staff')) ||
                    (jobPosition.diningRoomAttendant && jobPositionsString.includes('dining room')) ||
                    (jobPosition.personalChef && jobPositionsString.includes('personal chef')) ||
                    (jobPosition.eventCoordinator && jobPositionsString.includes('event coordinator')) ||
                    (jobPosition.householdAdministrator && jobPositionsString.includes('household administrator')) ||
                    (jobPosition.domesticAssistant && jobPositionsString.includes('domestic assistant'))
                );
            });
        }

        // Filter by job country (using country_apply_for_job field)
        if (Object.values(jobCountry).some(v => v)) {
            result = result.filter(candidate => {
                const applyForCountry = candidate.country_apply_for_job?.toLowerCase() || '';
                return (
                    (jobCountry.qatar && applyForCountry.includes('qatar')) ||
                    (jobCountry.uae && (applyForCountry.includes('uae') || applyForCountry.includes('united arab emirates') || applyForCountry.includes('dubai') || applyForCountry.includes('abu dhabi'))) ||
                    (jobCountry.saudiArabia && (applyForCountry.includes('saudi') || applyForCountry.includes('ksa') || applyForCountry.includes('riyadh') || applyForCountry.includes('jeddah'))) ||
                    (jobCountry.kuwait && applyForCountry.includes('kuwait')) ||
                    (jobCountry.bahrain && applyForCountry.includes('bahrain')) ||
                    (jobCountry.oman && applyForCountry.includes('oman')) ||
                    (jobCountry.usa && (applyForCountry.includes('usa') || applyForCountry.includes('united states') || applyForCountry.includes('america'))) ||
                    (jobCountry.canada && applyForCountry.includes('canada')) ||
                    (jobCountry.uk && (applyForCountry.includes('uk') || applyForCountry.includes('united kingdom') || applyForCountry.includes('england') || applyForCountry.includes('britain'))) ||
                    (jobCountry.australia && applyForCountry.includes('australia')) ||
                    (jobCountry.germany && applyForCountry.includes('germany')) ||
                    (jobCountry.france && applyForCountry.includes('france')) ||
                    (jobCountry.italy && applyForCountry.includes('italy')) ||
                    (jobCountry.spain && applyForCountry.includes('spain')) ||
                    (jobCountry.netherlands && applyForCountry.includes('netherlands')) ||
                    (jobCountry.belgium && applyForCountry.includes('belgium')) ||
                    (jobCountry.switzerland && applyForCountry.includes('switzerland')) ||
                    (jobCountry.sweden && applyForCountry.includes('sweden')) ||
                    (jobCountry.norway && applyForCountry.includes('norway')) ||
                    (jobCountry.denmark && applyForCountry.includes('denmark')) ||
                    (jobCountry.finland && applyForCountry.includes('finland')) ||
                    (jobCountry.japan && applyForCountry.includes('japan')) ||
                    (jobCountry.southKorea && (applyForCountry.includes('south korea') || applyForCountry.includes('korea'))) ||
                    (jobCountry.singapore && applyForCountry.includes('singapore')) ||
                    (jobCountry.malaysia && applyForCountry.includes('malaysia')) ||
                    (jobCountry.china && applyForCountry.includes('china')) ||
                    (jobCountry.hongKong && (applyForCountry.includes('hong kong') || applyForCountry.includes('hongkong'))) ||
                    (jobCountry.newZealand && (applyForCountry.includes('new zealand') || applyForCountry.includes('new zealand'))) ||
                    (jobCountry.southAfrica && (applyForCountry.includes('south africa') || applyForCountry.includes('south africa'))) ||
                    (jobCountry.brazil && applyForCountry.includes('brazil')) ||
                    (jobCountry.mexico && applyForCountry.includes('mexico')) ||
                    (jobCountry.argentina && applyForCountry.includes('argentina')) ||
                    (jobCountry.chile && applyForCountry.includes('chile')) ||
                    (jobCountry.colombia && applyForCountry.includes('colombia')) ||
                    (jobCountry.peru && applyForCountry.includes('peru')) ||
                    (jobCountry.egypt && applyForCountry.includes('egypt')) ||
                    (jobCountry.morocco && applyForCountry.includes('morocco')) ||
                    (jobCountry.algeria && applyForCountry.includes('algeria')) ||
                    (jobCountry.tunisia && applyForCountry.includes('tunisia')) ||
                    (jobCountry.jordan && applyForCountry.includes('jordan')) ||
                    (jobCountry.lebanon && applyForCountry.includes('lebanon')) ||
                    (jobCountry.iraq && applyForCountry.includes('iraq')) ||
                    (jobCountry.iran && applyForCountry.includes('iran')) ||
                    (jobCountry.turkey && applyForCountry.includes('turkey')) ||
                    (jobCountry.cyprus && applyForCountry.includes('cyprus')) ||
                    (jobCountry.malta && applyForCountry.includes('malta')) ||
                    (jobCountry.greece && applyForCountry.includes('greece')) ||
                    (jobCountry.portugal && applyForCountry.includes('portugal')) ||
                    (jobCountry.austria && applyForCountry.includes('austria')) ||
                    (jobCountry.hungary && applyForCountry.includes('hungary')) ||
                    (jobCountry.poland && applyForCountry.includes('poland')) ||
                    (jobCountry.czechRepublic && (applyForCountry.includes('czech') || applyForCountry.includes('czech republic'))) ||
                    (jobCountry.slovakia && applyForCountry.includes('slovakia')) ||
                    (jobCountry.slovenia && applyForCountry.includes('slovenia')) ||
                    (jobCountry.croatia && applyForCountry.includes('croatia')) ||
                    (jobCountry.romania && applyForCountry.includes('romania')) ||
                    (jobCountry.bulgaria && applyForCountry.includes('bulgaria')) ||
                    (jobCountry.serbia && applyForCountry.includes('serbia')) ||
                    (jobCountry.montenegro && applyForCountry.includes('montenegro')) ||
                    (jobCountry.albania && applyForCountry.includes('albania')) ||
                    (jobCountry.northMacedonia && (applyForCountry.includes('north macedonia') || applyForCountry.includes('macedonia'))) ||
                    (jobCountry.bosniaHerzegovina && (applyForCountry.includes('bosnia') || applyForCountry.includes('herzegovina'))) ||
                    (jobCountry.kosovo && applyForCountry.includes('kosovo')) ||
                    (jobCountry.estonia && applyForCountry.includes('estonia')) ||
                    (jobCountry.latvia && applyForCountry.includes('latvia')) ||
                    (jobCountry.lithuania && applyForCountry.includes('lithuania')) ||
                    (jobCountry.belarus && applyForCountry.includes('belarus')) ||
                    (jobCountry.ukraine && applyForCountry.includes('ukraine')) ||
                    (jobCountry.moldova && applyForCountry.includes('moldova')) ||
                    (jobCountry.georgia && applyForCountry.includes('georgia')) ||
                    (jobCountry.armenia && applyForCountry.includes('armenia')) ||
                    (jobCountry.azerbaijan && applyForCountry.includes('azerbaijan')) ||
                    (jobCountry.kazakhstan && applyForCountry.includes('kazakhstan')) ||
                    (jobCountry.uzbekistan && applyForCountry.includes('uzbekistan')) ||
                    (jobCountry.turkmenistan && applyForCountry.includes('turkmenistan')) ||
                    (jobCountry.kyrgyzstan && applyForCountry.includes('kyrgyzstan')) ||
                    (jobCountry.tajikistan && applyForCountry.includes('tajikistan')) ||
                    (jobCountry.afghanistan && applyForCountry.includes('afghanistan')) ||
                    (jobCountry.pakistan && applyForCountry.includes('pakistan')) ||
                    (jobCountry.india && applyForCountry.includes('india')) ||
                    (jobCountry.bangladesh && applyForCountry.includes('bangladesh')) ||
                    (jobCountry.sriLanka && (applyForCountry.includes('sri lanka') || applyForCountry.includes('sri lanka'))) ||
                    (jobCountry.nepal && applyForCountry.includes('nepal')) ||
                    (jobCountry.bhutan && applyForCountry.includes('bhutan')) ||
                    (jobCountry.myanmar && applyForCountry.includes('myanmar')) ||
                    (jobCountry.thailand && applyForCountry.includes('thailand')) ||
                    (jobCountry.laos && applyForCountry.includes('laos')) ||
                    (jobCountry.cambodia && applyForCountry.includes('cambodia')) ||
                    (jobCountry.vietnam && applyForCountry.includes('vietnam')) ||
                    (jobCountry.indonesia && applyForCountry.includes('indonesia')) ||
                    (jobCountry.philippines && applyForCountry.includes('philippines')) ||
                    (jobCountry.brunei && applyForCountry.includes('brunei')) ||
                    (jobCountry.eastTimor && (applyForCountry.includes('east timor') || applyForCountry.includes('timor-leste'))) ||
                    (jobCountry.papuaNewGuinea && (applyForCountry.includes('papua new guinea') || applyForCountry.includes('papua new guinea'))) ||
                    (jobCountry.fiji && applyForCountry.includes('fiji')) ||
                    (jobCountry.solomonIslands && (applyForCountry.includes('solomon islands') || applyForCountry.includes('solomon islands'))) ||
                    (jobCountry.vanuatu && applyForCountry.includes('vanuatu')) ||
                    (jobCountry.samoa && applyForCountry.includes('samoa')) ||
                    (jobCountry.tonga && applyForCountry.includes('tonga')) ||
                    (jobCountry.marshallIslands && (applyForCountry.includes('marshall islands') || applyForCountry.includes('marshall islands'))) ||
                    (jobCountry.micronesia && applyForCountry.includes('micronesia')) ||
                    (jobCountry.palau && applyForCountry.includes('palau')) ||
                    (jobCountry.nauru && applyForCountry.includes('nauru')) ||
                    (jobCountry.tuvalu && applyForCountry.includes('tuvalu')) ||
                    (jobCountry.kiribati && applyForCountry.includes('kiribati'))
                );
            });
        }

        // Filter by candidate nationality
        const selectedLocations = [];
        if (candidateLocation.india) selectedLocations.push('india');
        if (candidateLocation.bangladesh) selectedLocations.push('bangladesh');
        if (candidateLocation.nepal) selectedLocations.push('nepal');
        if (candidateLocation.sriLanka) selectedLocations.push('sri lanka', 'sri lankan');
        if (candidateLocation.pakistan) selectedLocations.push('pakistan');
        if (candidateLocation.philippines) selectedLocations.push('philippines');
        if (candidateLocation.indonesia) selectedLocations.push('indonesia');
        if (candidateLocation.myanmar) selectedLocations.push('myanmar', 'burma');
        if (candidateLocation.vietnam) selectedLocations.push('vietnam');
        if (candidateLocation.cambodia) selectedLocations.push('cambodia');
        if (candidateLocation.thailand) selectedLocations.push('thailand');
        if (candidateLocation.ethiopia) selectedLocations.push('ethiopia');
        if (candidateLocation.kenya) selectedLocations.push('kenya');
        if (candidateLocation.uganda) selectedLocations.push('uganda');
        if (candidateLocation.tanzania) selectedLocations.push('tanzania');
        if (candidateLocation.rwanda) selectedLocations.push('rwanda');
        if (candidateLocation.ghana) selectedLocations.push('ghana');
        if (candidateLocation.nigeria) selectedLocations.push('nigeria');
        if (candidateLocation.sierraLeone) selectedLocations.push('sierra leone');
        if (candidateLocation.burundi) selectedLocations.push('burundi');

        if (selectedLocations.length > 0) {
            result = result.filter(candidate => {
                const nationality = candidate.nationality?.toLowerCase() || '';
                return selectedLocations.some(location => nationality.includes(location));
            });
        }

        // Filter by job type (using current_work_status)
        if (
            jobType.fullTime || jobType.partTime || jobType.liveIn || jobType.liveOut ||
            jobType.temporary || jobType.permanent || jobType.internship || jobType.contractual ||
            jobType.freelance || jobType.volunteer || jobType.fresher
        ) {
            result = result.filter(candidate => {
                const type = candidate.job_type?.toLowerCase() || '';
                return (
                    (jobType.fullTime && type.includes('full time')) ||
                    (jobType.partTime && type.includes('part time')) ||
                    (jobType.liveIn && type.includes('live in')) ||
                    (jobType.liveOut && type.includes('live out')) ||
                    (jobType.temporary && type.includes('temporary')) ||
                    (jobType.permanent && type.includes('permanent')) ||
                    (jobType.internship && type.includes('internship')) ||
                    (jobType.contractual && type.includes('contractual')) ||
                    (jobType.freelance && type.includes('freelance')) ||
                    (jobType.volunteer && type.includes('volunteer')) ||
                    (jobType.fresher && type.includes('fresher'))
                );
            });
        }

        // Filter by contract status (using visa_type)
        if (contractStatus.permanent || contractStatus.temporary || contractStatus.contract) {
            result = result.filter(candidate => {
                const status = candidate.visa_type?.toLowerCase();
                return (contractStatus.permanent && status?.includes('permanent')) ||
                    (contractStatus.temporary && status?.includes('temporary')) ||
                    (contractStatus.contract && status?.includes('contract'));
            });
        }

        // Filter by posted by (using source - assuming this field exists)
        if (postedBy.agency || postedBy.directEmployer) {
            result = result.filter(candidate => {
                const source = candidate.source?.toLowerCase();
                return (postedBy.agency && source?.includes('agency')) ||
                    (postedBy.directEmployer && source?.includes('direct'));
            });
        }

        // Filter by language (using language array)
        if (
            language.english || language.mandarin || language.arabic || language.hindi ||
            language.tagalog || language.cantonese || language.malay || language.tamil
        ) {
            result = result.filter(candidate => {
                const langs = Array.isArray(candidate.language)
                    ? candidate.language.map(l => l.language?.toLowerCase() || l?.toLowerCase() || '').join(' ')
                    : (candidate.language?.toLowerCase() || '');

                return (
                    (language.english && langs.includes('english')) ||
                    (language.mandarin && langs.includes('mandarin')) ||
                    (language.arabic && langs.includes('arabic')) ||
                    (language.hindi && langs.includes('hindi')) ||
                    (language.tagalog && langs.includes('tagalog')) ||
                    (language.cantonese && langs.includes('cantonese')) ||
                    (language.malay && langs.includes('malay')) ||
                    (language.tamil && langs.includes('tamil'))
                );
            });
        }

        // Filter by main skills (using main_skills array)
        if (
            mainSkills.childcare || mainSkills.elderlyCare || mainSkills.cooking ||
            mainSkills.cleaning || mainSkills.laundry || mainSkills.ironing ||
            mainSkills.petCare || mainSkills.gardening
        ) {
            result = result.filter(candidate => {
                const skills = Array.isArray(candidate.main_skills)
                    ? candidate.main_skills.join(' ').toLowerCase()
                    : (candidate.main_skills?.toLowerCase() || '');

                return (
                    (mainSkills.childcare && skills.includes('childcare')) ||
                    (mainSkills.elderlyCare && skills.includes('elderly care')) ||
                    (mainSkills.cooking && skills.includes('cooking')) ||
                    (mainSkills.cleaning && skills.includes('cleaning')) ||
                    (mainSkills.laundry && skills.includes('laundry')) ||
                    (mainSkills.ironing && skills.includes('ironing')) ||
                    (mainSkills.petCare && skills.includes('pet care')) ||
                    (mainSkills.gardening && skills.includes('gardening'))
                );
            });
        }

        // Filter by start date (using preferred_start_date)
        if (startDate) {
            try {
                const selectedDate = new Date(startDate);
                selectedDate.setHours(0, 0, 0, 0);

                result = result.filter(candidate => {
                    if (!candidate.preferred_start_date) return false;

                    try {
                        const candidateDate = new Date(candidate.preferred_start_date);
                        candidateDate.setHours(0, 0, 0, 0);
                        return candidateDate >= selectedDate;
                    } catch (e) {
                        console.error('Error parsing candidate date:', candidate.preferred_start_date, e);
                        return false;
                    }
                });
            } catch (e) {
                console.error('Error parsing selected date:', startDate, e);
            }
        }

        if (searchTerm) {
            result = result.filter(candidate => {
                const fullName = `${candidate.first_name || ''} ${candidate.last_name || ''}`.toLowerCase();
                const nationality = candidate.nationality?.toLowerCase() || '';
                const category = candidate.category?.toLowerCase() || '';
                const currentCountry = candidate.current_country?.toLowerCase() || '';
                const jobPositions = safeParseArray(candidate.job_position).join(' ').toLowerCase();
                const rawJobPosition = (candidate.job_position || '').toString().toLowerCase();
                const rawDrivingLicense = (candidate.driving_license_country || '').toString().toLowerCase();
                const drivingLicenseCountries = getCandidateLicenseSearchValue(candidate);
                return (
                    fullName.includes(searchTerm) ||
                    nationality.includes(searchTerm) ||
                    category.includes(searchTerm) ||
                    currentCountry.includes(searchTerm) ||
                    jobPositions.includes(searchTerm) ||
                    rawJobPosition.includes(searchTerm) ||
                    rawDrivingLicense.includes(searchTerm) ||
                    drivingLicenseCountries.includes(searchTerm)
                );
            });
        }

        setFilteredCandidates(result);
    }, [
        candidates,
        jobPosition,
        candidateLocation,
        jobCountry,
        jobType,
        contractStatus,
        postedBy,
        language,
        mainSkills,
        startDate,
        searchTerm
    ]);

    // Shortlist functionality
    const handleShortlistClick = async (candidate) => {
        const isSubscriptionActive = hasActiveSubscription();

        if (!isSubscriptionActive) {
            Swal.fire({
                icon: 'warning',
                title: 'Subscription Required',
                text: 'Shortlist feature is available only for active Silver and Gold plan subscribers',
            });
            return;
        }

        const candidateUserId = candidate.user_id;
        const isCurrentlyShortlisted = shortlistedCandidates[candidateUserId];

        try {
            Swal.fire({
                title: isCurrentlyShortlisted ? 'Removing from shortlist...' : 'Adding to shortlist...',
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showLoading();
                }
            });

            if (isCurrentlyShortlisted) {
                // Remove from shortlist
                const shortlistEntryId = shortlistedCandidates[candidateUserId];
                const response = await fetch(`${BaseUrl}/shortlist/${shortlistEntryId}`, {
                    method: 'DELETE',
                });

                if (!response.ok) {
                    throw new Error('Failed to remove candidate from shortlist');
                }

                setShortlistedCandidates(prev => {
                    const newState = { ...prev };
                    delete newState[candidateUserId];
                    return newState;
                });

                Swal.fire({
                    icon: 'success',
                    title: 'Removed!',
                    text: 'Candidate removed from shortlist successfully!',
                    confirmButtonText: 'OK',
                });
            } else {
                // Add to shortlist
                const shortlistData = {
                    user_id: candidateUserId,
                    employer_id: agencyId, // Using agencyId as employer_id
                    employer_source: "Agency",
                    first_name: candidate.first_name?.split('@')[0] || candidate.first_name || 'Candidate',
                    email_id: candidate.email_id || candidate.email || ''
                };

                const response = await fetch(`${BaseUrl}/shortlist`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(shortlistData)
                });

                const data = await response.json();

                if (!response.ok) {
                    throw new Error(data.message || 'Failed to add candidate to shortlist');
                }

                setShortlistedCandidates(prev => ({
                    ...prev,
                    [candidateUserId]: data.data.id
                }));

                Swal.fire({
                    icon: 'success',
                    title: 'Success!',
                    text: 'Candidate added to shortlist successfully!',
                    confirmButtonText: 'OK',
                });
            }
        } catch (error) {
            console.error('Error toggling shortlist:', error);
            Swal.fire({
                icon: 'error',
                title: 'Failed',
                text: error.message || 'An error occurred. Please try again.',
            });
        }
    };

    // Share functionality
    const handleShareClick = (candidate) => {
        const isSubscriptionActive = hasActiveSubscription();

        if (!isSubscriptionActive) {
            Swal.fire({
                icon: 'warning',
                title: 'Subscription Required',
                text: 'Share feature is available only for active Silver and Gold plan subscribers',
            });
            return;
        }

        const candidateName = candidate.first_name?.split('@')[0] || 'Candidate';
        const candidateAge = candidate.age ? `${candidate.age} years` : '';
        const nationality = candidate.nationality || '';

        const jobPosition = Array.isArray(candidate.job_position)
            ? candidate.job_position.join(', ')
            : candidate.job_position || 'Domestic Worker';

        const experience = candidate.total_work_experience || 'Not specified';
        const currentLocation = candidate.current_country || 'Not specified';

        const shareText = `Check out ${candidateName}'s profile - ${jobPosition} | ${nationality} | ${candidateAge} | ${experience} experience | Currently in ${currentLocation}. Find more candidates on Gulf Worker.`;
        const safeName = encodeURIComponent(candidateName || 'candidate');
        const shareUrl = `${window.location.origin}/candidateview/${candidate.user_id}/${safeName}?viewer=agency`;
        const fullShareContent = `${shareText} ${shareUrl}`;

        if (navigator.share) {
            navigator.share({
                title: `${candidateName} - ${jobPosition}`,
                text: shareText,
                url: shareUrl,
            }).catch((error) => console.log('Error sharing:', error));
        } else {
            setSelectedCandidate(candidate);
            setShareContent(fullShareContent);
            setShareUrl(shareUrl);
            setShowShareModal(true);
        }
    };

    // Message functionality
    const handleMessageClick = (candidate) => {
        setSelectedCandidate(candidate);
        setShowMessageModal(true);
    };

    const handleCloseMessageModal = () => {
        setShowMessageModal(false);
        setMessageContent('');
        setSelectedCandidate(null);
    };

    const handleSendMessage = async () => {
        if (!messageContent.trim() || !selectedCandidate) {
            Swal.fire({
                icon: 'warning',
                title: 'Oops...',
                text: 'Please enter a message',
            });
            return;
        }

        try {
            Swal.fire({
                title: 'Sending message...',
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showLoading();
                }
            });

            const storeResponse = await fetch(`${BaseUrl}/message`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    emp_id: agencyId,
                    job_seeker_id: selectedCandidate.user_id,
                    message: messageContent
                })
            });

            const storeData = await storeResponse.json();

            if (!storeResponse.ok) {
                throw new Error(storeData.message || 'Failed to store message');
            }

            const emailMessageHTML = buildCandidateEmailHTML(selectedCandidate, messageContent);
            const emailResponse = await fetch(`${BaseUrl}/api/send-email`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    to_email: selectedCandidate.email_id,
                    subject: `Message regarding your application`,
                    message: emailMessageHTML
                })
            });

            const emailData = await emailResponse.json();

            if (!emailResponse.ok) {
                throw new Error(emailData.message || 'Failed to send email');
            }

            Swal.fire({
                icon: 'success',
                title: 'Success!',
                text: 'Message sent successfully!',
                timer: 2000,
                showConfirmButton: false
            }).then(() => {
                handleCloseMessageModal();
                setMessageContent("I'm interested");
            });

        } catch (error) {
            console.error('Error:', error);
            Swal.fire({
                icon: 'error',
                title: 'Failed',
                text: error.message || 'An error occurred. Please try again.',
            });
        }
    };

    // Report functionality
    const handleReportClick = (candidate) => {
        setSelectedCandidateForReport(candidate);
        setShowReportModal(true);
    };

    // Share utility functions
    const shareViaWhatsApp = (text) => {
        const encodedText = encodeURIComponent(text);
        window.open(`https://wa.me/?text=${encodedText}`, '_blank');
    };

    const shareViaFacebook = (url) => {
        window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`, '_blank');
    };

    const shareViaTwitter = (text) => {
        const encodedText = encodeURIComponent(text);
        window.open(`https://twitter.com/intent/tweet?text=${encodedText}`, '_blank');
    };

    const shareViaLinkedIn = (url) => {
        window.open(`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`, '_blank');
    };

    const copyToClipboard = (text) => {
        navigator.clipboard.writeText(text).then(() => {
            Swal.fire({
                icon: 'success',
                title: 'Copied!',
                text: 'Link copied to clipboard',
                timer: 1500,
                showConfirmButton: false
            });
        });
    };

    // WhatsApp functionality with contact unlock
    const handleWhatsAppClick = async (candidate) => {
        if (!agencyId) {
            Swal.fire({ icon: 'warning', title: 'Login Required', text: 'Please login as an agency to contact candidates' });
            return;
        }

        try {
            // First check if already unlocked
            const checkRes = await fetch(`${BaseUrl}/api/agency/contact-unlock/check?agency_id=${agencyId}&candidate_user_id=${candidate.user_id}`);
            const checkData = await checkRes.json();

            if (checkData.unlocked) {
                // Already unlocked - proceed directly
                openWhatsApp(candidate);
                return;
            }

            // Check subscription info
            const featureRes = await fetch(`${BaseUrl}/api/agency/check-feature?agencyId=${agencyId}&feature=contact_unlock&category=contact`);
            const featureData = await featureRes.json();

            if (!featureData.allowed) {
                if (featureData.reason === 'no_subscription') {
                    Swal.fire({
                        icon: 'warning', title: 'No Subscription',
                        text: 'You need an active Candidate Contact subscription to view contact details.',
                        confirmButtonText: 'View Plans', showCancelButton: true
                    }).then(r => { if (r.isConfirmed) navigate('/a-subscriptionplans'); });
                } else if (featureData.reason === 'limit_reached') {
                    Swal.fire({ icon: 'error', title: 'Limit Reached', text: `You have used all ${featureData.limit} contact unlocks for your plan.` });
                } else if (featureData.reason === 'insufficient_wallet') {
                    Swal.fire({
                        icon: 'error', title: 'Insufficient Balance',
                        text: `Your contact wallet balance (${featureData.balance}) is less than the unlock cost (${featureData.required}). Please top up.`,
                        confirmButtonText: 'Top Up', showCancelButton: true
                    }).then(r => { if (r.isConfirmed) navigate('/a-subscriptionplans'); });
                } else {
                    Swal.fire({ icon: 'warning', title: 'Subscription Required', text: 'Please subscribe to a Candidate Contact plan.' });
                }
                return;
            }

            // For PPC, show confirmation with cost
            if (featureData.plan_type === 'pay_per_click') {
                const result = await Swal.fire({
                    title: 'Unlock Contact Details?',
                    html: `
                        <div style="text-align: left; background: #fff; border-radius: 12px; padding: 5px; font-family: 'Inter', sans-serif;">
                            <div style="background: #f8f9fa; border-radius: 10px; padding: 15px; border: 1px solid #e9ecef;">
                                <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 12px;">
                                    <div style="display: flex; align-items: center; color: #495057;">
                                        <span style="margin-right: 8px;">💰</span>
                                        <span style="font-weight: 500;">Unlock Cost</span>
                                    </div>
                                    <span style="font-weight: 700; color: #212529; font-size: 1.1rem;">${featureData.price_per_unit} <span style="font-size: 0.8em; font-weight: 400; color: #6c757d;">Units</span></span>
                                </div>
                                
                                <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 12px;">
                                    <div style="display: flex; align-items: center; color: #495057;">
                                        <span style="margin-right: 8px;">🕒</span>
                                        <span style="font-weight: 500;">Access Duration</span>
                                    </div>
                                    <span style="font-weight: 600; color: #212529;">12 Hours</span>
                                </div>
                                
                                <div style="margin-top: 15px; padding-top: 12px; border-top: 2px dashed #dee2e6; display: flex; justify-content: space-between; align-items: center;">
                                    <div style="display: flex; align-items: center; color: #495057;">
                                        <span style="margin-right: 8px;">💳</span>
                                        <span style="font-weight: 500;">Wallet Balance</span>
                                    </div>
                                    <span style="font-weight: 700; color: #28a745;">${featureData.wallet_balance}</span>
                                </div>
                            </div>
                            <p style="margin-top: 15px; color: #868e96; font-size: 0.85rem; line-height: 1.4; text-align: center;">
                                Confirming will deduct the units and reveal contact details instantly.
                            </p>
                        </div>
                    `,
                    confirmButtonText: 'Unlock & View',
                    showCancelButton: true,
                    confirmButtonColor: '#28a745',
                    cancelButtonColor: '#6c757d',
                    reverseButtons: true,
                    didOpen: () => {
                        const confirmBtn = Swal.getConfirmButton();
                        const cancelBtn = Swal.getCancelButton();
                        confirmBtn.style.width = '160px';
                        cancelBtn.style.width = '160px';
                        confirmBtn.style.padding = '12px 0';
                        cancelBtn.style.padding = '12px 0';
                    }
                });
                if (!result.isConfirmed) return;
            }

            // Perform unlock
            const unlockRes = await fetch(`${BaseUrl}/api/agency/contact-unlock`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ agency_id: agencyId, candidate_user_id: candidate.user_id })
            });
            const unlockData = await unlockRes.json();

            if (unlockData.unlocked || unlockData.already_unlocked) {
                // Add to unlockedIds state to update UI immediately
                setUnlockedIds(prev => [...new Set([...prev, candidate.user_id])]);
                openWhatsApp(candidate);
            } else {
                Swal.fire({ icon: 'error', title: 'Error', text: unlockData.error || 'Failed to unlock contact.' });
            }
        } catch (err) {
            console.error('handleWhatsAppClick error:', err);
            Swal.fire({ icon: 'error', title: 'Error', text: 'Something went wrong. Please try again.' });
        }
    };

    const openWhatsApp = (candidate) => {
        let whatsappNumber = candidate.whatsapp_number || '9820867896';
        const cleanNumber = whatsappNumber.replace(/\D/g, '');
        let finalNumber = cleanNumber;

        if (cleanNumber.startsWith('91') && cleanNumber.length === 12) {
            finalNumber = cleanNumber;
        } else if (cleanNumber.length === 10) {
            finalNumber = '91' + cleanNumber;
        } else if (cleanNumber.length < 10) {
            finalNumber = '919820867896';
        } else {
            finalNumber = cleanNumber;
        }

        const jobPosition = Array.isArray(candidate.job_position)
            ? candidate.job_position.join(', ')
            : (candidate.job_position || 'candidate');

        const message = `Hi, I'm interested in your ${jobPosition} profile from Gulf Worker website`;
        window.open(`https://wa.me/${finalNumber}?text=${encodeURIComponent(message)}`, '_blank');
    };

    // Call functionality with contact unlock
    const initiateCall = async (candidate) => {
        if (!agencyId) {
            Swal.fire({ icon: 'warning', title: 'Login Required', text: 'Please login as an agency to contact candidates' });
            return;
        }

        try {
            // First check if already unlocked
            const checkRes = await fetch(`${BaseUrl}/api/agency/contact-unlock/check?agency_id=${agencyId}&candidate_user_id=${candidate.user_id}`);
            const checkData = await checkRes.json();

            if (checkData.unlocked) {
                openCall(candidate);
                return;
            }

            // Check subscription info
            const featureRes = await fetch(`${BaseUrl}/api/agency/check-feature?agencyId=${agencyId}&feature=contact_unlock&category=contact`);
            const featureData = await featureRes.json();

            if (!featureData.allowed) {
                if (featureData.reason === 'no_subscription') {
                    Swal.fire({
                        icon: 'warning', title: 'No Subscription',
                        text: 'You need an active Candidate Contact subscription to call candidates.',
                        confirmButtonText: 'View Plans', showCancelButton: true
                    }).then(r => { if (r.isConfirmed) navigate('/a-subscriptionplans'); });
                } else if (featureData.reason === 'limit_reached') {
                    Swal.fire({ icon: 'error', title: 'Limit Reached', text: `You have used all ${featureData.limit} contact unlocks.` });
                } else if (featureData.reason === 'insufficient_wallet') {
                    Swal.fire({
                        icon: 'error', title: 'Insufficient Balance',
                        text: `Your contact wallet balance is too low. Please top up.`,
                        confirmButtonText: 'Top Up', showCancelButton: true
                    }).then(r => { if (r.isConfirmed) navigate('/a-subscriptionplans'); });
                } else {
                    Swal.fire({ icon: 'warning', title: 'Subscription Required', text: 'Please subscribe to a Candidate Contact plan.' });
                }
                return;
            }

            // For PPC, show confirmation
            if (featureData.plan_type === 'pay_per_click') {
                const result = await Swal.fire({
                    title: 'Unlock Contact Details?',
                    html: `
                        <div style="text-align: left; background: #fff; border-radius: 12px; padding: 5px; font-family: 'Inter', sans-serif;">
                            <div style="background: #f8f9fa; border-radius: 10px; padding: 15px; border: 1px solid #e9ecef;">
                                <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 12px;">
                                    <div style="display: flex; align-items: center; color: #495057;">
                                        <span style="margin-right: 8px;">💰</span>
                                        <span style="font-weight: 500;">Unlock Cost</span>
                                    </div>
                                    <span style="font-weight: 700; color: #212529; font-size: 1.1rem;">${featureData.price_per_unit} <span style="font-size: 0.8em; font-weight: 400; color: #6c757d;">Units</span></span>
                                </div>
                                
                                <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 12px;">
                                    <div style="display: flex; align-items: center; color: #495057;">
                                        <span style="margin-right: 8px;">🕒</span>
                                        <span style="font-weight: 500;">Access Duration</span>
                                    </div>
                                    <span style="font-weight: 600; color: #212529;">12 Hours</span>
                                </div>
                                
                                <div style="margin-top: 15px; padding-top: 12px; border-top: 2px dashed #dee2e6; display: flex; justify-content: space-between; align-items: center;">
                                    <div style="display: flex; align-items: center; color: #495057;">
                                        <span style="margin-right: 8px;">💳</span>
                                        <span style="font-weight: 500;">Wallet Balance</span>
                                    </div>
                                    <span style="font-weight: 700; color: #28a745;">${featureData.wallet_balance}</span>
                                </div>
                            </div>
                            <p style="margin-top: 15px; color: #868e96; font-size: 0.85rem; line-height: 1.4; text-align: center;">
                                Confirming will deduct the units and reveal contact details instantly.
                            </p>
                        </div>
                    `,
                    confirmButtonText: 'Unlock & Call',
                    showCancelButton: true,
                    confirmButtonColor: '#28a745',
                    cancelButtonColor: '#6c757d',
                    reverseButtons: true,
                    didOpen: () => {
                        const confirmBtn = Swal.getConfirmButton();
                        const cancelBtn = Swal.getCancelButton();
                        confirmBtn.style.width = '160px';
                        cancelBtn.style.width = '160px';
                        confirmBtn.style.padding = '12px 0';
                        cancelBtn.style.padding = '12px 0';
                    }
                });
                if (!result.isConfirmed) return;
            }

            // Perform unlock
            const unlockRes = await fetch(`${BaseUrl}/api/agency/contact-unlock`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ agency_id: agencyId, candidate_user_id: candidate.user_id })
            });
            const unlockData = await unlockRes.json();

            if (unlockData.unlocked || unlockData.already_unlocked) {
                // Add to unlockedIds state to update UI immediately
                setUnlockedIds(prev => [...new Set([...prev, candidate.user_id])]);
                openCall(candidate);
            } else {
                Swal.fire({ icon: 'error', title: 'Error', text: unlockData.error || 'Failed to unlock contact.' });
            }
        } catch (err) {
            console.error('initiateCall error:', err);
            Swal.fire({ icon: 'error', title: 'Error', text: 'Something went wrong. Please try again.' });
        }
    };

    const openCall = (candidate) => {
        let phoneNumber = candidate.whatsapp_number || candidate.phone_number || '9820867896';
        const cleanNumber = phoneNumber.replace(/[^\d+]/g, '');
        let finalNumber = cleanNumber;
        if (!cleanNumber.startsWith('+')) {
            if (cleanNumber.startsWith('91') && cleanNumber.length === 12) {
                finalNumber = '+' + cleanNumber;
            } else if (cleanNumber.length === 10) {
                finalNumber = '+91' + cleanNumber;
            } else {
                finalNumber = '+919820867896';
            }
        }
        window.location.href = `tel:${finalNumber}`;
    };

    useEffect(() => {
        const fetchShortlistedStatus = async () => {
            try {
                const response = await fetch(`${BaseUrl}/shortlist/employer/${agencyId}`);
                if (response.ok) {
                    const data = await response.json();
                    const shortlistedMap = {};
                    data.forEach(entry => {
                        shortlistedMap[entry.user_id] = entry.id;
                    });
                    setShortlistedCandidates(shortlistedMap);
                }
            } catch (error) {
                console.error('Error fetching shortlisted status:', error);
            }
        };

        if (agencyId) {
            fetchShortlistedStatus();
        }
    }, [agencyId]);

    if (loading) {
        return (
            <>
                <AgencyNavbar />
                <div className="text-center mt-5">Loading candidates...</div>
            </>
        );
    }

    if (error) {
        return (
            <>
                <AgencyNavbar />
                <div className="text-center mt-5 text-danger">Error: {error}</div>
            </>
        );
    }

    return (
        <>
            <AgencyNavbar />
            <SendAlertScrollPrompt
                pageKey="agency-view-candidates"
                pageLabel="Agency Candidates Page"
                jobPosition="Candidate"
                user={user}
                navigate={navigate}
                targetRoute="/agency-send-alert"
                targetRoles={['agency', 'agency_admin']}
                targetRoleLabel="agency"
                registerDefaultTab="agency"
                loginDefaultTab="agency"
                prefillJobPositionOnContinue={false}
            />
            <Container fluid className="p-3 viewcandidates-container-agency">

                {/* Message Modal */}
                <Modal show={showMessageModal} onHide={handleCloseMessageModal} size="lg">
                    <Modal.Header closeButton>
                        <Modal.Title>Message {selectedCandidate?.first_name}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form.Group controlId="messageContent">
                            <Form.Label>Your Message</Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={5}
                                value={messageContent}
                                onChange={(e) => setMessageContent(e.target.value)}
                                placeholder={`Write your message to ${selectedCandidate?.first_name}...`}
                            />
                        </Form.Group>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleCloseMessageModal}>
                            Close
                        </Button>
                        <Button variant="primary" onClick={handleSendMessage}>
                            Send Message
                        </Button>
                    </Modal.Footer>
                </Modal>

                {/* Share Modal */}
                <Modal show={showShareModal} onHide={() => setShowShareModal(false)} centered>
                    <Modal.Header closeButton>
                        <Modal.Title>Share Candidate Profile</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="text-center">
                        <p className="mb-4">Share this candidate profile via:</p>
                        <div className="d-flex justify-content-center gap-3 mb-4">
                            <Button variant="success" className="rounded-circle share-btn" onClick={() => shareViaWhatsApp(shareContent)}>
                                <i className="bi bi-whatsapp fs-4"></i>
                            </Button>
                            <Button variant="primary" className="rounded-circle share-btn" onClick={() => shareViaFacebook(shareUrl)}>
                                <i className="bi bi-facebook fs-4"></i>
                            </Button>
                            <Button variant="info" className="rounded-circle share-btn" onClick={() => shareViaTwitter(shareContent)}>
                                <i className="bi bi-twitter fs-4"></i>
                            </Button>
                            <Button variant="primary" style={{ backgroundColor: '#0077b5' }} className="rounded-circle share-btn" onClick={() => shareViaLinkedIn(shareUrl)}>
                                <i className="bi bi-linkedin fs-4"></i>
                            </Button>
                            <Button variant="secondary" className="rounded-circle share-btn" onClick={() => copyToClipboard(shareUrl)}>
                                <i className="bi bi-link-45deg fs-4"></i>
                            </Button>
                        </div>
                        <Form.Group>
                            <Form.Label>Share this text:</Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={3}
                                value={shareContent}
                                readOnly
                                onClick={(e) => e.target.select()}
                            />
                        </Form.Group>
                    </Modal.Body>
                </Modal>

                <Row>
                    {/* Filter Section */}
                    {isMobile && (
                        <div className="mb-3">
                            <button
                                className="btn btn-primary w-100"
                                onClick={() => setShowFiltersMobile(!showFiltersMobile)}
                            >
                                <i className="bi bi-funnel me-2"></i>
                                {showFiltersMobile ? 'Hide Filters' : 'Show Filters'}
                            </button>
                        </div>
                    )}

                    <Col md={3} lg={2}>
                        {(showFiltersMobile || !isMobile) && (
                            <div className="viewjobposting-filters p-3 border rounded bg-light" style={{ marginTop: '20px' }}>
                                {/* Filter Header with Refresh Button */}
                                <div className="d-flex justify-content-between align-items-center mb-4">
                                    <h5 className="mb-0">Filters</h5>
                                    <button
                                        className="btn btn-sm btn-outline-secondary"
                                        onClick={resetAllFilters}
                                        title="Reset all filters"
                                    >
                                        <i className="bi bi-arrow-clockwise"></i> Reset
                                    </button>
                                </div>

                                {/* Candidate Nationality Filter */}
                                <div className="mb-4 viewjobposting-filter-section">
                                    <div
                                        className="d-flex flex-row justify-content-between align-items-center cursor-pointer mb-2"
                                        onClick={() => setShowLocation(!showLocation)}
                                    >
                                        <strong>Candidate Nationality</strong>
                                        <i className={`bi ${showLocation ? 'bi-chevron-down' : 'bi-chevron-right'}`}></i>
                                    </div>
                                    {showLocation && (
                                        <div className="d-flex flex-column gap-2">
                                            {[
                                                { id: 'india', name: 'India' },
                                                { id: 'bangladesh', name: 'Bangladesh' },
                                                { id: 'nepal', name: 'Nepal' },
                                                { id: 'sriLanka', name: 'Sri Lanka' },
                                                { id: 'pakistan', name: 'Pakistan' },
                                                { id: 'philippines', name: 'Philippines' },
                                                { id: 'indonesia', name: 'Indonesia' },
                                                { id: 'myanmar', name: 'Myanmar' },
                                                { id: 'vietnam', name: 'Vietnam' },
                                                { id: 'cambodia', name: 'Cambodia' },
                                                { id: 'thailand', name: 'Thailand' },
                                                { id: 'ethiopia', name: 'Ethiopia' },
                                                { id: 'kenya', name: 'Kenya' },
                                                { id: 'uganda', name: 'Uganda' },
                                                { id: 'tanzania', name: 'Tanzania' },
                                                { id: 'rwanda', name: 'Rwanda' },
                                                { id: 'ghana', name: 'Ghana' },
                                                { id: 'nigeria', name: 'Nigeria' },
                                                { id: 'sierraLeone', name: 'Sierra Leone' },
                                                { id: 'burundi', name: 'Burundi' }
                                            ].slice(0, showMoreLocations ? 16 : 5).map((location) => (
                                                <div key={location.id} className="form-check">
                                                    <input
                                                        className="form-check-input-allcandidates"
                                                        type="checkbox"
                                                        id={`location-${location.id}`}
                                                        checked={candidateLocation[location.id]}
                                                        onChange={(e) => handleCandidateLocationChange({
                                                            target: {
                                                                name: location.id,
                                                                checked: e.target.checked
                                                            }
                                                        })}
                                                    />
                                                    <label className="form-check-label" htmlFor={`location-${location.id}`}>
                                                        {location.name}
                                                    </label>
                                                </div>
                                            ))}
                                            {Object.keys(candidateLocation).length > 5 && (
                                                <button
                                                    className="btn btn-link p-0 text-decoration-none viewjobposting-text-primary"
                                                    onClick={toggleMoreLocations}
                                                >
                                                    {showMoreLocations ? 'Show Less' : 'Show More'}
                                                </button>
                                            )}
                                        </div>
                                    )}
                                </div>

                                {/* Candidate Job Country Filter */}
                                <div className="mb-4 viewjobposting-filter-section">
                                    <div
                                        className="d-flex flex-row justify-content-between align-items-center cursor-pointer mb-2"
                                        onClick={() => setShowMoreJobCountry(!showMoreJobCountry)}
                                    >
                                        <strong>Candidate Job Country</strong>
                                        <i className={`bi ${showMoreJobCountry ? 'bi-chevron-down' : 'bi-chevron-right'}`}></i>
                                    </div>
                                    {showMoreJobCountry && (
                                        <div className="d-flex flex-column gap-2">
                                            {[
                                                // Gulf Countries
                                                { id: 'qatar', name: 'Qatar' },
                                                { id: 'uae', name: 'UAE/Dubai' },
                                                { id: 'saudiArabia', name: 'Saudi Arabia' },
                                                { id: 'kuwait', name: 'Kuwait' },
                                                { id: 'bahrain', name: 'Bahrain' },
                                                { id: 'oman', name: 'Oman' },

                                                // North America
                                                { id: 'usa', name: 'USA' },
                                                { id: 'canada', name: 'Canada' },

                                                // Europe
                                                { id: 'uk', name: 'United Kingdom' },
                                                { id: 'germany', name: 'Germany' },
                                                { id: 'france', name: 'France' },
                                                { id: 'italy', name: 'Italy' },
                                                { id: 'spain', name: 'Spain' },
                                                { id: 'netherlands', name: 'Netherlands' },
                                                { id: 'belgium', name: 'Belgium' },
                                                { id: 'switzerland', name: 'Switzerland' },
                                                { id: 'sweden', name: 'Sweden' },
                                                { id: 'norway', name: 'Norway' },
                                                { id: 'denmark', name: 'Denmark' },
                                                { id: 'finland', name: 'Finland' },
                                                { id: 'austria', name: 'Austria' },
                                                { id: 'hungary', name: 'Hungary' },
                                                { id: 'poland', name: 'Poland' },
                                                { id: 'czechRepublic', name: 'Czech Republic' },
                                                { id: 'slovakia', name: 'Slovakia' },
                                                { id: 'slovenia', name: 'Slovenia' },
                                                { id: 'croatia', name: 'Croatia' },
                                                { id: 'romania', name: 'Romania' },
                                                { id: 'bulgaria', name: 'Bulgaria' },
                                                { id: 'serbia', name: 'Serbia' },
                                                { id: 'montenegro', name: 'Montenegro' },
                                                { id: 'albania', name: 'Albania' },
                                                { id: 'northMacedonia', name: 'North Macedonia' },
                                                { id: 'bosniaHerzegovina', name: 'Bosnia & Herzegovina' },
                                                { id: 'kosovo', name: 'Kosovo' },
                                                { id: 'estonia', name: 'Estonia' },
                                                { id: 'latvia', name: 'Latvia' },
                                                { id: 'lithuania', name: 'Lithuania' },
                                                { id: 'belarus', name: 'Belarus' },
                                                { id: 'ukraine', name: 'Ukraine' },
                                                { id: 'moldova', name: 'Moldova' },
                                                { id: 'georgia', name: 'Georgia' },
                                                { id: 'armenia', name: 'Armenia' },
                                                { id: 'azerbaijan', name: 'Azerbaijan' },

                                                // Asia Pacific
                                                { id: 'japan', name: 'Japan' },
                                                { id: 'southKorea', name: 'South Korea' },
                                                { id: 'singapore', name: 'Singapore' },
                                                { id: 'malaysia', name: 'Malaysia' },
                                                { id: 'china', name: 'China' },
                                                { id: 'hongKong', name: 'Hong Kong' },
                                                { id: 'australia', name: 'Australia' },
                                                { id: 'newZealand', name: 'New Zealand' },

                                                // South Asia
                                                { id: 'india', name: 'India' },
                                                { id: 'pakistan', name: 'Pakistan' },
                                                { id: 'bangladesh', name: 'Bangladesh' },
                                                { id: 'sriLanka', name: 'Sri Lanka' },
                                                { id: 'nepal', name: 'Nepal' },
                                                { id: 'bhutan', name: 'Bhutan' },
                                                { id: 'myanmar', name: 'Myanmar' },
                                                { id: 'thailand', name: 'Thailand' },
                                                { id: 'laos', name: 'Laos' },
                                                { id: 'cambodia', name: 'Cambodia' },
                                                { id: 'vietnam', name: 'Vietnam' },
                                                { id: 'indonesia', name: 'Indonesia' },
                                                { id: 'philippines', name: 'Philippines' },
                                                { id: 'brunei', name: 'Brunei' },
                                                { id: 'eastTimor', name: 'East Timor' },

                                                // Middle East & Africa
                                                { id: 'turkey', name: 'Turkey' },
                                                { id: 'cyprus', name: 'Cyprus' },
                                                { id: 'malta', name: 'Malta' },
                                                { id: 'egypt', name: 'Egypt' },
                                                { id: 'morocco', name: 'Morocco' },
                                                { id: 'algeria', name: 'Algeria' },
                                                { id: 'tunisia', name: 'Tunisia' },
                                                { id: 'jordan', name: 'Jordan' },
                                                { id: 'lebanon', name: 'Lebanon' },
                                                { id: 'iraq', name: 'Iraq' },
                                                { id: 'iran', name: 'Iran' },
                                                { id: 'southAfrica', name: 'South Africa' },

                                                // Central Asia
                                                { id: 'kazakhstan', name: 'Kazakhstan' },
                                                { id: 'uzbekistan', name: 'Uzbekistan' },
                                                { id: 'turkmenistan', name: 'Turkmenistan' },
                                                { id: 'kyrgyzstan', name: 'Kyrgyzstan' },
                                                { id: 'tajikistan', name: 'Tajikistan' },
                                                { id: 'afghanistan', name: 'Afghanistan' },

                                                // Latin America
                                                { id: 'brazil', name: 'Brazil' },
                                                { id: 'mexico', name: 'Mexico' },
                                                { id: 'argentina', name: 'Argentina' },
                                                { id: 'chile', name: 'Chile' },
                                                { id: 'colombia', name: 'Colombia' },
                                                { id: 'peru', name: 'Peru' },

                                                // Pacific Islands
                                                { id: 'papuaNewGuinea', name: 'Papua New Guinea' },
                                                { id: 'fiji', name: 'Fiji' },
                                                { id: 'solomonIslands', name: 'Solomon Islands' },
                                                { id: 'vanuatu', name: 'Vanuatu' },
                                                { id: 'samoa', name: 'Samoa' },
                                                { id: 'tonga', name: 'Tonga' },
                                                { id: 'marshallIslands', name: 'Marshall Islands' },
                                                { id: 'micronesia', name: 'Micronesia' },
                                                { id: 'palau', name: 'Palau' },
                                                { id: 'nauru', name: 'Nauru' },
                                                { id: 'tuvalu', name: 'Tuvalu' },
                                                { id: 'kiribati', name: 'Kiribati' }
                                            ].map((country) => (
                                                <div key={country.id} className="form-check">
                                                    <input
                                                        className="form-check-input-allcandidates"
                                                        type="checkbox"
                                                        id={`jobCountry-${country.id}`}
                                                        checked={jobCountry[country.id]}
                                                        onChange={(e) => handleJobCountryChange({
                                                            target: {
                                                                name: country.id,
                                                                checked: e.target.checked
                                                            }
                                                        })}
                                                    />
                                                    <label className="form-check-label" htmlFor={`jobCountry-${country.id}`}>
                                                        {country.name}
                                                    </label>
                                                </div>
                                            ))}
                                            <button
                                                className="btn btn-link p-0 text-decoration-none viewjobposting-text-primary"
                                                onClick={() => setShowMoreJobCountry(!showMoreJobCountry)}
                                            >
                                                {showMoreJobCountry ? 'Show Less' : 'Show More'}
                                            </button>
                                        </div>
                                    )}
                                </div>

                                {/* Job Position Filter */}
                                <div className="mb-4 viewjobposting-filter-section">
                                    <div
                                        className="d-flex flex-row justify-content-between align-items-center cursor-pointer mb-2"
                                        onClick={() => setShowMoreJobPosition(!showMoreJobPosition)}
                                    >
                                        <strong>Job Position</strong>
                                        <i className={`bi ${showMoreJobPosition ? 'bi-chevron-down' : 'bi-chevron-right'}`}></i>
                                    </div>
                                    {showMoreJobPosition && (
                                        <div className="d-flex flex-column gap-2">
                                            {[
                                                { id: 'maid', name: 'Maid' },
                                                { id: 'driver', name: 'Driver' },
                                                { id: 'cook', name: 'Cook' },
                                                { id: 'nanny', name: 'Nanny' },
                                                { id: 'nurse', name: 'Nurse' },
                                                { id: 'houseboy', name: 'Houseboy' },
                                                { id: 'tailor', name: 'Tailor' },
                                                { id: 'teacher', name: 'Teacher' },
                                                { id: 'trainer', name: 'Trainer' },
                                                { id: 'gardener', name: 'Gardener' },
                                                { id: 'butler', name: 'Butler' },
                                                { id: 'housekeeper', name: 'Housekeeper' },
                                                { id: 'laundryWorker', name: 'Laundry Worker' },
                                                { id: 'personalAssistant', name: 'Personal Assistant' },
                                                { id: 'caregiver', name: 'Caregiver' },
                                                { id: 'elderCareCompanion', name: 'Elder Care Companion' },
                                                { id: 'petSitter', name: 'Pet Sitter' },
                                                { id: 'houseManager', name: 'House Manager' },
                                                { id: 'cleaner', name: 'Cleaner' },
                                                { id: 'maintenanceWorker', name: 'Maintenance Worker' },
                                                { id: 'babySitter', name: 'Baby Sitter' },
                                                { id: 'tutor', name: 'Tutor' },
                                                { id: 'chauffeur', name: 'Chauffeur' },
                                                { id: 'housemaid', name: 'Housemaid' },
                                                { id: 'kitchenStaff', name: 'Kitchen Staff' },
                                                { id: 'diningRoomAttendant', name: 'Dining Room Attendant' },
                                                { id: 'personalChef', name: 'Personal Chef' },
                                                { id: 'eventCoordinator', name: 'Event Coordinator' },
                                                { id: 'householdAdministrator', name: 'Household Administrator' },
                                                { id: 'domesticAssistant', name: 'Domestic Assistant' }
                                            ].slice(0, showMoreJobPosition ? 30 : 5).map((position) => (
                                                <div key={position.id} className="form-check">
                                                    <input
                                                        className="form-check-input-allcandidates"
                                                        type="checkbox"
                                                        id={`position-${position.id}`}
                                                        checked={jobPosition[position.id]}
                                                        onChange={(e) => handleJobPositionChange({
                                                            target: {
                                                                name: position.id,
                                                                checked: e.target.checked
                                                            }
                                                        })}
                                                    />
                                                    <label className="form-check-label" htmlFor={`position-${position.id}`}>
                                                        {position.name}
                                                    </label>
                                                </div>
                                            ))}
                                            {Object.keys(jobPosition).length > 5 && (
                                                <button
                                                    className="btn btn-link p-0 text-decoration-none viewjobposting-text-primary"
                                                    onClick={() => setShowMoreJobPosition(!showMoreJobPosition)}
                                                >
                                                    {showMoreJobPosition ? 'Show Less' : 'Show More'}
                                                </button>
                                            )}
                                        </div>
                                    )}
                                </div>

                                {/* Job Type Filter */}
                                <div className="mb-4 viewjobposting-filter-section">
                                    <div
                                        className="d-flex flex-row justify-content-between align-items-center cursor-pointer mb-2"
                                        onClick={() => setShowMoreJobType(!showMoreJobType)}
                                    >
                                        <strong>Job Type</strong>
                                        <i className={`bi ${showMoreJobType ? 'bi-chevron-down' : 'bi-chevron-right'}`}></i>
                                    </div>
                                    {showMoreJobType && (
                                        <div className="d-flex flex-column gap-2">
                                            {[
                                                { id: 'fullTime', name: 'Full Time' },
                                                { id: 'partTime', name: 'Part Time' },
                                                { id: 'liveIn', name: 'Live In' },
                                                { id: 'liveOut', name: 'Live Out' },
                                                { id: 'temporary', name: 'Temporary' },
                                                { id: 'permanent', name: 'Permanent' },
                                                { id: 'internship', name: 'Internship' },
                                                { id: 'contractual', name: 'Contractual' },
                                                { id: 'freelance', name: 'Freelance' },
                                                { id: 'volunteer', name: 'Volunteer' },
                                                { id: 'fresher', name: 'Fresher' }
                                            ].slice(0, showMoreJobType ? 11 : 5).map((type) => (
                                                <div key={type.id} className="form-check">
                                                    <input
                                                        className="form-check-input-allcandidates"
                                                        type="checkbox"
                                                        id={`jobType-${type.id}`}
                                                        checked={jobType[type.id]}
                                                        onChange={(e) => handleJobTypeChange({
                                                            target: {
                                                                name: type.id,
                                                                checked: e.target.checked
                                                            }
                                                        })}
                                                    />
                                                    <label className="form-check-label" htmlFor={`jobType-${type.id}`}>
                                                        {type.name}
                                                    </label>
                                                </div>
                                            ))}
                                            {Object.keys(jobType).length > 5 && (
                                                <button
                                                    className="btn btn-link p-0 text-decoration-none viewjobposting-text-primary"
                                                    onClick={() => setShowMoreJobType(!showMoreJobType)}
                                                >
                                                    {showMoreJobType ? 'Show Less' : 'Show More'}
                                                </button>
                                            )}
                                        </div>
                                    )}
                                </div>

                                {/* Contract Status Filter */}
                                <div className="mb-4 viewjobposting-filter-section">
                                    <div
                                        className="d-flex flex-row justify-content-between align-items-center cursor-pointer mb-2"
                                        onClick={() => setShowContractStatus(!showContractStatus)}
                                    >
                                        <strong>Contract Status</strong>
                                        <i className={`bi ${showContractStatus ? 'bi-chevron-down' : 'bi-chevron-right'}`}></i>
                                    </div>
                                    {showContractStatus && (
                                        <div className="d-flex flex-column gap-2">
                                            {[
                                                { id: 'permanent', name: 'Permanent' },
                                                { id: 'temporary', name: 'Temporary' },
                                                { id: 'contract', name: 'Contract' }
                                            ].map((status) => (
                                                <div key={status.id} className="form-check">
                                                    <input
                                                        className="form-check-input-allcandidates"
                                                        type="checkbox"
                                                        id={`contract-${status.id}`}
                                                        checked={contractStatus[status.id]}
                                                        onChange={(e) => handleContractStatusChange({
                                                            target: {
                                                                name: status.id,
                                                                checked: e.target.checked
                                                            }
                                                        })}
                                                    />
                                                    <label className="form-check-label" htmlFor={`contract-${status.id}`}>
                                                        {status.name}
                                                    </label>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>

                                {/* Posted By Filter */}
                                <div className="mb-4 viewjobposting-filter-section">
                                    <div
                                        className="d-flex flex-row justify-content-between align-items-center cursor-pointer mb-2"
                                        onClick={() => setShowPostedBy(!showPostedBy)}
                                    >
                                        <strong>Post By</strong>
                                        <i className={`bi ${showPostedBy ? 'bi-chevron-down' : 'bi-chevron-right'}`}></i>
                                    </div>
                                    {showPostedBy && (
                                        <div className="d-flex flex-column gap-2">
                                            {[
                                                { id: 'agency', name: 'Agency' },
                                                { id: 'directEmployer', name: 'Direct Employer' }
                                            ].map((post) => (
                                                <div key={post.id} className="form-check">
                                                    <input
                                                        className="form-check-input-allcandidates"
                                                        type="checkbox"
                                                        id={`postedBy-${post.id}`}
                                                        checked={postedBy[post.id]}
                                                        onChange={(e) => handlePostedByChange({
                                                            target: {
                                                                name: post.id,
                                                                checked: e.target.checked
                                                            }
                                                        })}
                                                    />
                                                    <label className="form-check-label" htmlFor={`postedBy-${post.id}`}>
                                                        {post.name}
                                                    </label>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>

                                {/* Language Filter */}
                                <div className="mb-4 viewjobposting-filter-section">
                                    <div
                                        className="d-flex flex-row justify-content-between align-items-center cursor-pointer mb-2"
                                        onClick={() => setShowMoreLanguage(!showMoreLanguage)}
                                    >
                                        <strong>Language</strong>
                                        <i className={`bi ${showMoreLanguage ? 'bi-chevron-down' : 'bi-chevron-right'}`}></i>
                                    </div>
                                    {showMoreLanguage && (
                                        <div className="d-flex flex-column gap-2">
                                            {[
                                                { id: 'english', name: 'English' },
                                                { id: 'mandarin', name: 'Mandarin' },
                                                { id: 'arabic', name: 'Arabic' },
                                                { id: 'hindi', name: 'Hindi' },
                                                { id: 'tagalog', name: 'Tagalog' },
                                                { id: 'cantonese', name: 'Cantonese' },
                                                { id: 'malay', name: 'Malay' },
                                                { id: 'tamil', name: 'Tamil' }
                                            ].slice(0, showMoreLanguage ? 8 : 5).map((lang) => (
                                                <div key={lang.id} className="form-check">
                                                    <input
                                                        className="form-check-input-allcandidates"
                                                        type="checkbox"
                                                        id={`language-${lang.id}`}
                                                        checked={language[lang.id]}
                                                        onChange={(e) => handleLanguageChange({
                                                            target: {
                                                                name: lang.id,
                                                                checked: e.target.checked
                                                            }
                                                        })}
                                                    />
                                                    <label className="form-check-label" htmlFor={`language-${lang.id}`}>
                                                        {lang.name}
                                                    </label>
                                                </div>
                                            ))}
                                            {Object.keys(language).length > 5 && (
                                                <button
                                                    className="btn btn-link p-0 text-decoration-none viewjobposting-text-primary"
                                                    onClick={() => setShowMoreLanguage(!showMoreLanguage)}
                                                >
                                                    {showMoreLanguage ? 'Show Less' : 'Show More'}
                                                </button>
                                            )}
                                        </div>
                                    )}
                                </div>

                                {/* Main Skills Filter */}
                                <div className="mb-4 viewjobposting-filter-section">
                                    <div
                                        className="d-flex flex-row justify-content-between align-items-center cursor-pointer mb-2"
                                        onClick={() => setShowMoreMainSkills(!showMoreMainSkills)}
                                    >
                                        <strong>Main Skills</strong>
                                        <i className={`bi ${showMoreMainSkills ? 'bi-chevron-down' : 'bi-chevron-right'}`}></i>
                                    </div>
                                    {showMoreMainSkills && (
                                        <div className="d-flex flex-column gap-2">
                                            {[
                                                { id: 'childcare', name: 'Childcare' },
                                                { id: 'elderlyCare', name: 'Elderly Care' },
                                                { id: 'cooking', name: 'Cooking' },
                                                { id: 'cleaning', name: 'Cleaning' },
                                                { id: 'laundry', name: 'Laundry' },
                                                { id: 'ironing', name: 'Ironing' },
                                                { id: 'petCare', name: 'Pet Care' },
                                                { id: 'gardening', name: 'Gardening' }
                                            ].map((skill) => (
                                                <div key={skill.id} className="form-check">
                                                    <input
                                                        className="form-check-input-allcandidates"
                                                        type="checkbox"
                                                        id={`skill-${skill.id}`}
                                                        checked={mainSkills[skill.id]}
                                                        onChange={(e) => handleMainSkillsChange({
                                                            target: {
                                                                name: skill.id,
                                                                checked: e.target.checked
                                                            }
                                                        })}
                                                    />
                                                    <label className="form-check-label" htmlFor={`skill-${skill.id}`}>
                                                        {skill.name}
                                                    </label>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>

                                {/* Start Date Filter */}
                                <div className="mb-4 viewjobposting-filter-section">
                                    <div
                                        className="d-flex flex-row justify-content-between align-items-center cursor-pointer mb-2"
                                        onClick={() => setShowStartDate(!showStartDate)}
                                    >
                                        <strong>Start Date</strong>
                                        <i className={`bi ${showStartDate ? 'bi-chevron-down' : 'bi-chevron-right'}`}></i>
                                    </div>
                                    {showStartDate && (
                                        <div className="p-2 bg-white rounded border">
                                            <input
                                                type="date"
                                                className="form-control"
                                                value={startDate}
                                                onChange={handleStartDateChange}
                                            />
                                        </div>
                                    )}
                                </div>
                            </div>
                        )}
                    </Col>

                    {/* Candidates List */}
                    <Col md={showFiltersMobile || !isMobile ? 9 : 12} lg={showFiltersMobile || !isMobile ? 10 : 12}>
                        <div className="candidate-toolbar-agency" style={{ marginTop: '20px' }}>
                            <Form className="candidate-toolbar-form-agency" onSubmit={handleSearchSubmit}>
                                <div className="input-group w-100 candidate-search-group" style={{ maxWidth: '100%' }}>
                                    <Form.Control
                                        type="text"
                                        placeholder="Search by name, nationality, job position, or license country"
                                        value={searchInput}
                                        onChange={(e) => setSearchInput(e.target.value)}
                                        className="candidate-search-input"
                                        style={{ minWidth: 0, height: '48px' }}
                                    />
                                    <Button
                                        type="submit"
                                        variant="primary"
                                        className="px-4 candidate-search-button fw-bold"
                                        style={{ whiteSpace: 'nowrap', flexShrink: 0, minWidth: '90px', height: '48px' }}
                                    >
                                        Search
                                    </Button>
                                </div>
                            </Form>
                            <Button
                                type="button"
                                variant="success"
                                className="candidate-send-alert-button-agency"
                                onClick={handleSendBulkMessagesClick}
                            >
                                <HiOutlineBellAlert className="me-2" />
                                Send Bulk Messages
                            </Button>
                        </div>
                        {filteredCandidates.length === 0 ? (
                            <div className="text-center no-jobs-message">No candidates match your filters</div>
                        ) : (
                            <Row>
                                {filteredCandidates.map((candidate) => (
                                    <Col lg={4} md={6} sm={12} xs={12} className="mb-4 candidate-col" key={candidate.id}>
                                        <CandidateCard
                                            candidate={candidate}
                                            planName={planName}
                                            userPlanStartDate={planStartDate}
                                            userPlanEndDate={planEndDate}
                                            isUnlocked={unlockedIds.includes(candidate.user_id)}
                                            onViewClick={() => handleViewClick(candidate)}
                                            onMessageClick={() => handleMessageClick(candidate)}
                                            onReportClick={() => handleReportClick(candidate)}
                                            onShareClick={() => handleShareClick(candidate)}
                                            onShortlistClick={() => handleShortlistClick(candidate)}
                                            onWhatsAppClick={() => handleWhatsAppClick(candidate)}
                                            onCallClick={() => initiateCall(candidate)}
                                            isShortlisted={!!shortlistedCandidates[candidate.user_id]}
                                        />
                                    </Col>
                                ))}
                            </Row>
                        )}
                    </Col>
                </Row>
            </Container>

            <AgencyReportCandidate
                candidate={selectedCandidateForReport}
                show={showReportModal}
                onHide={() => setShowReportModal(false)}
            />
            <Footer />
        </>
    );
}

function CandidateCard({
    candidate,
    planName,
    userPlanStartDate,
    userPlanEndDate,
    onViewClick,
    onMessageClick,
    onReportClick,
    onShareClick,
    onShortlistClick,
    onWhatsAppClick,
    onCallClick,
    isShortlisted,
    isUnlocked
}) {
    // Helper function to format date
    const formatDate = (dateString) => {
        if (!dateString) return 'Not specified';
        const date = new Date(dateString);
        const day = date.getDate().toString().padStart(2, '0'); // Ensure 2 digits
        const months = [
            'January', 'February', 'March', 'April', 'May', 'June',
            'July', 'August', 'September', 'October', 'November', 'December'
        ];
        const month = months[date.getMonth()];
        const year = date.getFullYear();
        return `${day} ${month} ${year}`;
    };

    const parseToArraySafe = (val) => {
        if (!val) return [];
        if (Array.isArray(val)) return val;
        if (typeof val === 'string') {
            try {
                const parsed = JSON.parse(val.replace(/\\"/g, '"'));
                return Array.isArray(parsed) ? parsed : [parsed];
            } catch {
                return [val];
            }
        }
        return [val];
    };

    const getCandidateLicenseSearchValue = (candidate) => {
        const licenseItems = parseToArraySafe(candidate.driving_license_country)
            .map((item) => String(item || '').replace(/â€“|–/g, '-').trim())
            .filter(Boolean);

        return licenseItems
            .map((item) => item.split('-')[0].trim().toLowerCase())
            .filter(Boolean)
            .join(' ');
    };

    const getCandidateCategory = () => {
        return (
            candidate.category ||
            candidate.job_category ||
            candidate.domestic_worker_category ||
            candidate.worker_category ||
            candidate.candidate_category ||
            ''
        );
    };

    const isHospitalCategory = () => {
        const category = String(getCandidateCategory() || '').toLowerCase();
        return category.includes('hospital') || category.includes('healthcare');
    };

    const getNursingLicenseValue = () => {
        if (candidate.nurse_license_status) return candidate.nurse_license_status;
        const raw = candidate.nursing_license_countries || candidate.nursing_license_country;
        const items = parseToArraySafe(raw).map((item) => String(item).trim()).filter(Boolean);
        return items.length ? items.join(', ') : 'Not specified';
    };

    // Helper function to get languages - with default value
    const getLanguages = () => {
        if (!candidate.language || candidate.language.length === 0) {
            return 'English, Arabic'; // Default value
        }

        // Get language names from the array of objects
        const languages = candidate.language.map(lang => lang.language);

        // If there are 2 or more languages, show the first two
        if (languages.length >= 2) {
            return `${languages[0]}, ${languages[1]}`;
        }

        // If only 1 language exists, just show it
        return languages[0];
    };

    const handleCallAction = () => {
        if (onCallClick) onCallClick(candidate);
    };

    const handleWhatsAppClick = () => {
        if (onWhatsAppClick) onWhatsAppClick(candidate);
    };

    const handleShortlistClick = () => {
        if (onShortlistClick) onShortlistClick(candidate);
    };

    const handleShareClick = () => {
        if (onShareClick) onShareClick(candidate);
    };

    // Helper function to get main language (for backward compatibility)
    const getMainLanguage = () => {
        if (!candidate.language || candidate.language.length === 0) return 'English, Arabic';
        return `${candidate.language[0].language}`;
    };

    // Helper function to get accommodation preference - with default value
    const getAccommodationPreference = () => {
        if (!candidate.accommodation_preference || candidate.accommodation_preference === 'Not specified') {
            return 'Live in/Live Out'; // Default value
        }
        return candidate.accommodation_preference;
    };

    // Helper function to get visa status - with default value
    const getVisaStatus = () => {
        if (!candidate.visa_type || candidate.visa_type === 'Not specified') {
            return 'Looking for visa'; // Default value
        }
        return candidate.visa_type;
    };

    // Helper function to get available from date - with default value
    const getAvailableFrom = () => {
        const startDate = candidate.preferred_start_date;
        if (!startDate) return 'Immediate'; // Default value

        // Check if it's "Immediate" or similar text
        if (typeof startDate === 'string' && startDate.toLowerCase().includes('immediate')) {
            return 'Immediate';
        }

        try {
            // Try to parse as date
            const date = new Date(startDate);
            if (!isNaN(date.getTime())) {
                return date.toLocaleDateString('en-US', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric'
                });
            }
            // If not a valid date, return the original string
            return startDate;
        } catch (e) {
            // If parsing fails, return the original value
            return startDate || 'Immediate';
        }
    };

    // Helper function to get main skills
    const getMainSkills = () => {
        if (!candidate.main_skills || candidate.main_skills.length === 0) return 'Not specified';
        const firstSkill = candidate.main_skills[0];
        if (firstSkill.includes('["')) {
            try {
                const parsed = JSON.parse(firstSkill.replace(/\\/g, ''));
                if (Array.isArray(parsed)) {
                    return parsed.join(', ');
                }
                return parsed;
            } catch (e) {
                return firstSkill;
            }
        }
        return firstSkill;
    };

    // Check if user has active subscription
    const hasActiveSubscription = () => {
        const userPlan = planName?.toLowerCase();
        const hasValidPlan = userPlan?.includes('gold') || userPlan?.includes('silver');

        if (!hasValidPlan) return false;

        const currentDate = new Date();
        const planStartDateObj = new Date(userPlanStartDate);
        const planEndDateObj = new Date(userPlanEndDate);

        currentDate.setHours(0, 0, 0, 0);
        planStartDateObj.setHours(0, 0, 0, 0);
        planEndDateObj.setHours(0, 0, 0, 0);

        return currentDate >= planStartDateObj && currentDate <= planEndDateObj;
    };

    const isSubscriptionActive = hasActiveSubscription();

    const getCandidateDisplayName = () => {
        const fullNameFromParts = [candidate.first_name, candidate.last_name]
            .filter(Boolean)
            .join(' ')
            .trim();
        const rawName = String(candidate.full_name || candidate.name || fullNameFromParts || '').split('@')[0].trim();
        if (!rawName) return 'Candidate';
        return rawName.charAt(0).toUpperCase() + rawName.slice(1);
    };

    return (
        <Card className="h-100 shadow-sm rounded card-body-home-allcandidate">
            <Card.Body className="d-flex flex-column justify-content-between">
                <CandidateCardHeading candidate={candidate} />
                <div className="d-flex">
                    <div className="me-3 text-center" style={{ marginTop: '15px' }}>
                        <div className="candidate-label-container">
                            {/* ✅ Show Verified if status is verified */}
                            {Number(candidate.purchased_badge) === 1 && (
                                <div className="custom-label verified-label">
                                    <span className="verified-label-icon">&#10003;</span>
                                    <span>Verified</span>
                                </div>
                            )}

                            {/* ✅ Show New only if NOT verified and created within last 7 days */}
                            {candidate.verification_status?.toLowerCase() !== "verified" &&
                                candidate.created_at &&
                                moment().diff(moment(candidate.created_at), "days") <= 7 && (
                                    <div className="custom-label" style={{ width: "50%" }}>
                                        New
                                    </div>
                                )}
                        </div>

                        <div className="profile-img-container">
                            {/* ✅ Show Offer Badge only if verified AND has an offer */}
                            {hasVisibleOfferBadge(candidate) && (
                                <div className="allcandidates-offer-badge">{getVisibleOfferBadgeText(candidate)}</div>
                            )}

                            {candidate.profile_photo ? (
                                <Image
                                    src={candidate.profile_photo}
                                    alt="profile"
                                    roundedCircle
                                    className="border allcandidate-profile-photo"
                                />
                            ) : (
                                <div
                                    className="border allcandidate-profile-photo d-flex align-items-center justify-content-center bg-light rounded-circle"
                                    style={{ width: '90px', height: '90px' }}
                                >
                                    <i className="bi bi-person-fill text-muted" style={{ fontSize: '2.5rem' }}></i>
                                </div>
                            )}
                        </div>

                        <div className="very-active-label" style={{ color: hasHighlightedSourceLabel(candidate) ? 'green' : '#111', fontWeight: hasHighlightedSourceLabel(candidate) ? '500' : 'normal' }}>
                            {getVisibleSourceLabel(candidate)}
                        </div>
                    </div>

                    <div className="flex-grow-1 allcandidate-card-right" style={{ minWidth: 0 }}>
                        {Array.isArray(candidate.job_position) && candidate.job_position.some(pos =>
                            pos.toLowerCase().includes("nurse") || pos.toLowerCase().includes("midwife")) ? (
                            // ✅ Custom layout if job_position is Nurse
                            <>
                                <h6 className="fw-bold candidate-heading text-truncate mt-2">
                                    <span style={{ fontWeight: 500 }}>
                                        {candidate.first_name
                                            ? candidate.first_name.split("@")[0].charAt(0).toUpperCase() + candidate.first_name.split("@")[0].slice(1)
                                            : ""}
                                    </span>
                                    <span style={{ fontWeight: 'normal' }}>-{candidate.age}Y- </span>
                                    <span style={{ fontWeight: 'normal', color: 'green' }}>{candidate.nationality}</span>
                                </h6>
                                <ul className="small ps-3 mb-0 custom-list-candidate-agency agencycandidate-nurse-details">
                                    <li>
                                        <strong>Name - </strong>
                                        {getCandidateDisplayName()}
                                    </li>
                                    <li>
                                        <strong>Job Position - </strong>
                                        {Array.isArray(candidate.job_position)
                                            ? candidate.job_position.join(', ').trim() || 'Not specified'
                                            : (candidate.job_position || 'Not specified')}
                                    </li>
                                    {isHospitalCategory() && (
                                        <li>
                                            <strong>Nursing License - </strong>
                                            {getNursingLicenseValue()}
                                        </li>
                                    )}
                                    <li>
                                        <strong>Salary - </strong>
                                        {(() => {
                                            const usdAmount = candidate.expected_monthly_salary_usd
                                                ? parseFloat(candidate.expected_monthly_salary_usd)
                                                : 0;

                                            const localAmount = candidate.expected_monthly_salary
                                                ? parseFloat(candidate.expected_monthly_salary)
                                                : 0;

                                            const qarAmount = candidate.expected_monthly_salary_qar
                                                ? parseFloat(candidate.expected_monthly_salary_qar)
                                                : 0;

                                            if (usdAmount === 0 && localAmount === 0) {
                                                return "Negotiable";
                                            }

                                            let currencyCode = "";
                                            if (candidate.expected_monthly_salary_currency) {
                                                const match = candidate.expected_monthly_salary_currency.match(/^([A-Za-z]{3})/);
                                                currencyCode = match ? match[1] : candidate.expected_monthly_salary_currency.split(' ')[0];
                                            } else if (candidate.nationality) {
                                                const currencyMap = {
                                                    "India": "INR",
                                                    "Philippines": "PHP",
                                                    "Indonesia": "IDR",
                                                    "Sri Lanka": "LKR",
                                                    "Nepal": "NPR",
                                                    "Ghana": "GHS",
                                                    "Kenya": "KES",
                                                    "Uganda": "UGX",
                                                    "Burundi": "BIF",
                                                    "Vietnam": "VND",
                                                    "Thailand": "THB",
                                                    "Cambodia": "KHR",
                                                    "Tanzania": "TZS",
                                                    "Bangladesh": "BDT",
                                                    "Ethiopia": "ETB",
                                                    "Sierra Leone": "SLL"
                                                };
                                                currencyCode = currencyMap[candidate.nationality] || "Local";
                                            } else {
                                                currencyCode = "Local";
                                            }

                                            if (usdAmount > 0 && localAmount > 0) {
                                                return `${qarAmount} QAR / ${usdAmount} USD`;
                                            } else if (usdAmount > 0) {
                                                return `${usdAmount} USD`;
                                            } else if (localAmount > 0) {
                                                return `${localAmount} ${currencyCode}`;
                                            }

                                            return "Negotiable";
                                        })()}
                                    </li>
                                    <li>
                                        <strong>Experience -</strong>{' '}
                                        {candidate.total_work_experience || 'Not specified'}
                                    </li>
                                    <li>
                                        <strong>Language -</strong> {getLanguages()}
                                    </li>
                                    <li>
                                        <strong>Current Location -</strong>{' '}
                                        <span>{candidate.current_country || 'Not specified'}</span>
                                    </li>
                                    <li>
                                        <strong>Accommodation - </strong>{' '}
                                        <span>{getAccommodationPreference()}</span>
                                    </li>
                                    {!isHospitalCategory() && (
                                        <li>
                                            <strong>Visa Status - </strong>{' '}
                                            <span>{getVisaStatus()}</span>
                                        </li>
                                    )}
                                    <li>
                                        <strong>Available From - </strong>{' '}
                                        <span>{getAvailableFrom()}</span>
                                    </li>
                                </ul>
                            </>
                        ) : Array.isArray(candidate.job_position) && candidate.job_position.some(pos =>
                            pos.toLowerCase().includes("doctor")) ? (
                            // ✅ Custom layout if job_position is Doctor
                            <>
                                <h6 className="fw-bold candidate-heading text-truncate mt-2">
                                    <span style={{ fontWeight: 500 }}>
                                        Dr.{candidate.first_name
                                            ? candidate.first_name.split("@")[0].charAt(0).toUpperCase() + candidate.first_name.split("@")[0].slice(1)
                                            : ""}
                                    </span>
                                    <span style={{ fontWeight: 'normal' }}>-{candidate.age}years- </span><span style={{ fontWeight: 'normal', color: 'green' }}>{candidate.nationality}</span>
                                </h6>

                                <ul className="small ps-3 mb-0 custom-list-candidate-agency agencycandidate-doctor-details">
                                    <li>
                                        <strong>Name - </strong>
                                        Dr. {getCandidateDisplayName()}
                                    </li>
                                    <li>
                                        <strong>Job Position - </strong>
                                        {Array.isArray(candidate.job_position)
                                            ? candidate.job_position.join(', ').trim() || 'Not specified'
                                            : (candidate.job_position || 'Not specified')}
                                    </li>
                                    <li>
                                        <strong>Salary - </strong>
                                        {(() => {
                                            const usdAmount = candidate.expected_monthly_salary_usd
                                                ? parseFloat(candidate.expected_monthly_salary_usd)
                                                : 0;

                                            const localAmount = candidate.expected_monthly_salary
                                                ? parseFloat(candidate.expected_monthly_salary)
                                                : 0;

                                            const qarAmount = candidate.expected_monthly_salary_qar
                                                ? parseFloat(candidate.expected_monthly_salary_qar)
                                                : 0;

                                            if (usdAmount === 0 && localAmount === 0) {
                                                return "Negotiable";
                                            }

                                            let currencyCode = "";
                                            if (candidate.expected_monthly_salary_currency) {
                                                const match = candidate.expected_monthly_salary_currency.match(/^([A-Za-z]{3})/);
                                                currencyCode = match ? match[1] : candidate.expected_monthly_salary_currency.split(' ')[0];
                                            } else if (candidate.nationality) {
                                                const currencyMap = {
                                                    "India": "INR",
                                                    "Philippines": "PHP",
                                                    "Indonesia": "IDR",
                                                    "Sri Lanka": "LKR",
                                                    "Nepal": "NPR",
                                                    "Ghana": "GHS",
                                                    "Kenya": "KES",
                                                    "Uganda": "UGX",
                                                    "Burundi": "BIF",
                                                    "Vietnam": "VND",
                                                    "Thailand": "THB",
                                                    "Cambodia": "KHR",
                                                    "Tanzania": "TZS",
                                                    "Bangladesh": "BDT",
                                                    "Ethiopia": "ETB",
                                                    "Sierra Leone": "SLL"
                                                };
                                                currencyCode = currencyMap[candidate.nationality] || "Local";
                                            } else {
                                                currencyCode = "Local";
                                            }

                                            if (usdAmount > 0 && localAmount > 0) {
                                                return `${qarAmount} QAR / ${usdAmount} USD`;
                                            } else if (usdAmount > 0) {
                                                return `${usdAmount} USD`;
                                            } else if (localAmount > 0) {
                                                return `${localAmount} ${currencyCode}`;
                                            }

                                            return "Negotiable";
                                        })()}
                                    </li>
                                    <li>
                                        <strong>Experience -</strong>{' '}
                                        {candidate.total_work_experience || 'Not specified'}
                                    </li>
                                    <li>
                                        <strong>Language -</strong> {getLanguages()}
                                    </li>
                                    <li>
                                        <strong>Current Location -</strong>{' '}
                                        <span>{candidate.current_country || 'Not specified'}</span>
                                    </li>
                                    <li>
                                        <strong>Accommodation - </strong>{' '}
                                        <span>{getAccommodationPreference()}</span>
                                    </li>
                                    <li>
                                        <strong>Visa Status - </strong>{' '}
                                        <span>{getVisaStatus()}</span>
                                    </li>
                                    <li>
                                        <strong>Available From - </strong>{' '}
                                        <span>{getAvailableFrom()}</span>
                                    </li>
                                </ul>
                            </>
                        ) : Array.isArray(candidate.job_position) && candidate.job_position.some(pos =>
                            pos.toLowerCase().includes("driver")) ? (
                            // ✅ Custom layout if job_position is Driver
                            <>
                                <h6 className="fw-bold candidate-heading text-truncate mt-2">
                                    <span style={{ fontWeight: 500 }}>
                                        {candidate.first_name
                                            ? candidate.first_name.split("@")[0].charAt(0).toUpperCase() + candidate.first_name.split("@")[0].slice(1)
                                            : ""}
                                    </span>
                                    <span style={{ fontWeight: 'normal' }}>-{candidate.age}Y- </span>
                                    <span style={{ fontWeight: 'normal', color: 'green' }}>{candidate.nationality}</span>
                                </h6>

                                <ul className="small ps-3 mb-0 custom-list-candidate-agency agencycandidate-driver-details">
                                    <li>
                                        <strong>Name - </strong>
                                        {getCandidateDisplayName()}
                                    </li>
                                    <li>
                                        <strong>Job Position - </strong>
                                        {Array.isArray(candidate.job_position)
                                            ? candidate.job_position.join(', ').trim() || 'Not specified'
                                            : (candidate.job_position || 'Not specified')}
                                    </li>
                                    <li>
                                        <strong>Salary - </strong>
                                        {(() => {
                                            const usdAmount = candidate.expected_monthly_salary_usd
                                                ? parseFloat(candidate.expected_monthly_salary_usd)
                                                : 0;

                                            const localAmount = candidate.expected_monthly_salary
                                                ? parseFloat(candidate.expected_monthly_salary)
                                                : 0;

                                            const qarAmount = candidate.expected_monthly_salary_qar
                                                ? parseFloat(candidate.expected_monthly_salary_qar)
                                                : 0;

                                            if (usdAmount === 0 && localAmount === 0) {
                                                return "Negotiable";
                                            }

                                            let currencyCode = "";
                                            if (candidate.expected_monthly_salary_currency) {
                                                const match = candidate.expected_monthly_salary_currency.match(/^([A-Za-z]{3})/);
                                                currencyCode = match ? match[1] : candidate.expected_monthly_salary_currency.split(' ')[0];
                                            } else if (candidate.nationality) {
                                                const currencyMap = {
                                                    "India": "INR",
                                                    "Philippines": "PHP",
                                                    "Indonesia": "IDR",
                                                    "Sri Lanka": "LKR",
                                                    "Nepal": "NPR",
                                                    "Ghana": "GHS",
                                                    "Kenya": "KES",
                                                    "Uganda": "UGX",
                                                    "Burundi": "BIF",
                                                    "Vietnam": "VND",
                                                    "Thailand": "THB",
                                                    "Cambodia": "KHR",
                                                    "Tanzania": "TZS",
                                                    "Bangladesh": "BDT",
                                                    "Ethiopia": "ETB",
                                                    "Sierra Leone": "SLL"
                                                };
                                                currencyCode = currencyMap[candidate.nationality] || "Local";
                                            } else {
                                                currencyCode = "Local";
                                            }

                                            if (usdAmount > 0 && localAmount > 0) {
                                                return `${qarAmount} QAR / ${usdAmount} USD`;
                                            } else if (usdAmount > 0) {
                                                return `${usdAmount} USD`;
                                            } else if (localAmount > 0) {
                                                return `${localAmount} ${currencyCode}`;
                                            }

                                            return "Negotiable";
                                        })()}
                                    </li>

                                    <li>
                                        <strong>License - </strong>{' '}
                                        <span>
                                            {candidate.driving_license_country
                                                ? (() => {
                                                    try {
                                                        // Parse if it's a JSON string
                                                        let licenseData = candidate.driving_license_country;

                                                        // Check if it's a string that needs parsing
                                                        if (typeof licenseData === 'string' &&
                                                            (licenseData.startsWith('[') || licenseData.startsWith('"'))) {
                                                            licenseData = JSON.parse(licenseData);
                                                        }

                                                        // Handle array of licenses
                                                        if (Array.isArray(licenseData)) {
                                                            // Process each license to extract only country name
                                                            const processedLicenses = licenseData.map(license => {
                                                                if (typeof license === 'string') {
                                                                    // Extract country name before dash, or use the whole string if no dash
                                                                    const parts = license.split('–').map(part => part.trim());
                                                                    return parts[0]; // Return only the country name
                                                                }
                                                                return license;
                                                            });
                                                            return processedLicenses.join(', ');
                                                        }

                                                        // Handle single license (string)
                                                        if (typeof licenseData === 'string') {
                                                            // Extract country name before dash
                                                            const parts = licenseData.split('–').map(part => part.trim());
                                                            return parts[0]; // Return only the country name
                                                        }

                                                        return licenseData || 'Not specified';
                                                    } catch (e) {
                                                        // If parsing fails, treat as regular string and extract country
                                                        const licenseStr = String(candidate.driving_license_country);
                                                        const parts = licenseStr.split('–').map(part => part.trim());
                                                        return parts[0]; // Return only the country name
                                                    }
                                                })()
                                                : 'Not specified'
                                            }
                                        </span>
                                    </li>

                                    <li>
                                        <strong>Experience -</strong>{' '}
                                        {candidate.total_work_experience || 'Not specified'}
                                    </li>
                                    <li>
                                        <strong>Language -</strong> {getLanguages()}
                                    </li>
                                    <li>
                                        <strong>Current Location -</strong>{' '}
                                        <span>{candidate.current_country || 'Not specified'}</span>
                                    </li>
                                    <li>
                                        <strong>Accommodation - </strong>{' '}
                                        <span>{getAccommodationPreference()}</span>
                                    </li>
                                    <li>
                                        <strong>Available From - </strong>{' '}
                                        <span>{getAvailableFrom()}</span>
                                    </li>
                                </ul>
                            </>
                        ) : (
                            // ✅ Default layout for all other job_positions
                            <>
                                <h6 className="fw-bold candidate-heading text-truncate mt-2">
                                    <span style={{ fontWeight: 650 }}>
                                        {candidate.first_name
                                            ? candidate.first_name.split("@")[0].charAt(0).toUpperCase() + candidate.first_name.split("@")[0].slice(1)
                                            : ""}
                                    </span>
                                    <span style={{ fontWeight: 'normal' }}>-{candidate.age}Y- </span>
                                    <span style={{ fontWeight: 'normal', color: 'green' }}>{candidate.nationality}</span>
                                </h6>

                                <ul className="small ps-3 mb-0 custom-list-candidate-agency agencycandidate-normal-details">
                                    <li>
                                        <strong>Name - </strong>
                                        {getCandidateDisplayName()}
                                    </li>
                                    <li>
                                        <strong>Job Position - </strong>
                                        {Array.isArray(candidate.job_position)
                                            ? candidate.job_position.join(', ').trim() || 'Not specified'
                                            : (candidate.job_position || 'Not specified')}
                                    </li>
                                    <li>
                                        <strong>Salary - </strong>
                                        {(() => {
                                            const usdAmount = candidate.expected_monthly_salary_usd
                                                ? parseFloat(candidate.expected_monthly_salary_usd)
                                                : 0;

                                            const localAmount = candidate.expected_monthly_salary
                                                ? parseFloat(candidate.expected_monthly_salary)
                                                : 0;

                                            const qarAmount = candidate.expected_monthly_salary_qar
                                                ? parseFloat(candidate.expected_monthly_salary_qar)
                                                : 0;

                                            // Check if both USD and local amounts are 0 or not provided
                                            if (usdAmount === 0 && localAmount === 0) {
                                                return "Negotiable";
                                            }

                                            // Extract currency code from expected_monthly_salary_currency
                                            let currencyCode = "";
                                            if (candidate.expected_monthly_salary_currency) {
                                                // Get the first part before space or bracket (e.g., "INR" from "INR (India")
                                                const match = candidate.expected_monthly_salary_currency.match(/^([A-Za-z]{3})/);
                                                currencyCode = match ? match[1] : candidate.expected_monthly_salary_currency.split(' ')[0];
                                            } else if (candidate.nationality) {
                                                // Fallback: Map nationality to currency code
                                                const currencyMap = {
                                                    "India": "INR",
                                                    "Philippines": "PHP",
                                                    "Indonesia": "IDR",
                                                    "Sri Lanka": "LKR",
                                                    "Nepal": "NPR",
                                                    "Ghana": "GHS",
                                                    "Kenya": "KES",
                                                    "Uganda": "UGX",
                                                    "Burundi": "BIF",
                                                    "Vietnam": "VND",
                                                    "Thailand": "THB",
                                                    "Cambodia": "KHR",
                                                    "Tanzania": "TZS",
                                                    "Bangladesh": "BDT",
                                                    "Ethiopia": "ETB",
                                                    "Sierra Leone": "SLL"
                                                };
                                                currencyCode = currencyMap[candidate.nationality] || "Local";
                                            } else {
                                                currencyCode = "Local";
                                            }

                                            if (usdAmount > 0 && localAmount > 0) {
                                                return `${qarAmount} QAR / ${usdAmount} USD`;
                                            } else if (usdAmount > 0) {
                                                return `${usdAmount} USD`;
                                            } else if (localAmount > 0) {
                                                return `${localAmount} ${currencyCode}`;
                                            }

                                            return "Negotiable";
                                        })()}
                                    </li>
                                    <li>
                                        <strong>Experience -</strong>{' '}
                                        {candidate.total_work_experience || 'Not specified'}
                                    </li>
                                    <li>
                                        <strong>Language -</strong> {getLanguages()}
                                    </li>
                                    <li>
                                        <strong>Current Location -</strong>{' '}
                                        <span>{candidate.current_country || 'Not specified'}</span>
                                    </li>
                                    <li>
                                        <strong>Accommodation - </strong>{' '}
                                        <span>{getAccommodationPreference()}</span>
                                    </li>
                                    <li>
                                        <strong>Visa Status - </strong>{' '}
                                        <span>{getVisaStatus()}</span>
                                    </li>
                                    <li>
                                        <strong>Available From - </strong>{' '}
                                        <span>{getAvailableFrom()}</span>
                                    </li>
                                </ul>
                            </>
                        )}
                    </div>
                </div>

                                                {/* Buttons */}
                <Row className="mt-1">
                    <Col xs={3} className="px-1">
                        <Button
                            variant="light"
                            className="w-100 small-btn action-button"
                            onClick={(e) => {
                                e.stopPropagation();
                                window.dispatchEvent(new CustomEvent('initiate-video-call', { 
                                    detail: { 
                                        candidateId: candidate?.user_id || candidate?.id, 
                                        candidateName: candidate?.first_name 
                                    } 
                                }));
                            }}
                        >
                            <FaVideo className="text-primary" />
                        </Button>
                    </Col>
                    <Col xs={3} className="px-1">
                        <Button
                            variant="secondary" style={{ backgroundColor: '#7177a6' }}
                            className={`w-100 small-btn action-button gap-2 ${!((typeof isSubscriptionActive !== 'undefined' ? isSubscriptionActive : true) || (typeof isUnlocked !== 'undefined' ? isUnlocked : false)) ? 'opacity-50' : ''}`}
                            onClick={handleCallAction}
                        >
                            <FaPhoneAlt /> Call
                        </Button>
                    </Col>
                    <Col xs={3} className="px-1">
                        <Button variant="allcandidates-veiwbutton" className="w-100 small-btn action-button gap-2 allcandidates-veiwbutton" onClick={onViewClick}>
                            <FaEye /> View
                        </Button>
                    </Col>
                    <Col xs={3} className="px-1">
                        <Button
                            variant="success"
                            className={`w-100 small-btn action-button ${!((typeof isSubscriptionActive !== 'undefined' ? isSubscriptionActive : true) || (typeof isUnlocked !== 'undefined' ? isUnlocked : false)) ? 'opacity-50' : ''}`}
                            onClick={handleWhatsAppClick}
                        >
                            <i className="bi bi-whatsapp" />
                        </Button>
                    </Col>
                </Row>

                                                <Row className="mt-1 text-center text-muted small fw-medium border-top pt-2 last-buttons-row">
                    <Col
                        className={`cursor-pointer no-underline d-flex align-items-center justify-content-center ${!(isSubscriptionActive || isUnlocked) ? 'opacity-50' : ''}`}
                        onClick={handleShortlistClick}
                        style={{ whiteSpace: 'nowrap' }}
                    >
                        {isShortlisted ? (
                            <FaHeart className="text-danger me-1" />
                        ) : (
                            <FaRegHeart className="me-1" />
                        )}
                        Like
                    </Col>
                    <Col
                        className={`cursor-pointer no-underline d-flex align-items-center justify-content-center ${!(isSubscriptionActive || isUnlocked) ? 'opacity-50' : ''}`}
                        onClick={handleShareClick}
                        style={{ whiteSpace: 'nowrap' }}
                    >
                        <i className="bi bi-share me-1"></i> Share
                    </Col>
                    <Col className="cursor-pointer no-underline d-flex align-items-center justify-content-center" onClick={onMessageClick} style={{ whiteSpace: 'nowrap' }}>
                        <i className="bi bi-chat-dots me-1"></i> Message
                    </Col>
                    <Col className="cursor-pointer no-underline d-flex align-items-center justify-content-center" onClick={onReportClick} style={{ whiteSpace: 'nowrap' }}>
                        <i className="bi bi-flag me-1"></i> Report
                    </Col>
                </Row>
            </Card.Body>
        </Card>
    );
}

export default ViewCandidates;
